<main
  [attr.id]="isCorporate || isAdvisor ? null : 'main'"
  [ngClass]="isCorporate || isAdvisor ? '' : 'main'"
>
  <section class="section dashboard">
    <div class="row" *ngIf="viewPlan">
      <div class="col-12 mb-2">
        <h6
          class="admintitle"
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div>{{ lang?.Plans ?? "Plans" }}</div>
        </h6>
      </div>
    </div>
    <!-- plan categories -->
    <div
      class="row"
      *ngIf="isCorporate != true && isAdvisor != true"
      style="
        position: sticky;
        top: 60px;
        z-index: 999;
        background: white;
        margin: 0px;
      "
    >
      <div class="col-12 d-flex justify-content-evenly tabs">
        <div
          class="tab w-100 justify-content-between"
          *ngFor="let category of planCategories"
          [ngClass]="{ active: selectedPlanCategory == category }"
          (click)="handlePlanCategory(category)"
        >
          {{ category }}
        </div>
      </div>
    </div>

    <!-- corporate customers -->
    <div
      *ngIf="selectedPlanCategory == planCategories[0] || isCorporate == true"
    >
      <div class="main-div">
        <h6 class="subheading py-2">Corporate Level Group Plans</h6>
        <div class="scroll-container position-relative">
          <i
            *ngIf="isScrollable"
            class="chevron chevron-left fa bi-chevron-left left--chevron"
            (click)="scrollLeft()"
          ></i>

          <div #bulkPlans class="bulk-plans d-flex">
            <div *ngFor="let package of bulkPlansData">
              <div
                *ngIf="
                  package?.groups?.length > 0 && package?.published == true
                "
              >
                <div
                  class="planheadingwrap"
                  style="padding-left: 0px; margin-left: 5px"
                  *ngIf="package?.groups?.length >= 1"
                >
                  <div class="d-flex position-relative">
                    <h6
                      class="planheading panel-title ps-3"
                      [attr.data-bs-target]="'#collapsethreeBulk' + package?.id"
                      data-bs-toggle="collapse"
                      [attr.aria-expanded]="!isCollapsedBulk[package?.id]"
                      aria-controls="collapsethreeBulk{{ package?.id }}"
                      (click)="toggleBulkCollapse(package?.id)"
                      [ngClass]="
                        package?.name != undefined && package?.name != ''
                          ? ''
                          : 'no-package'
                      "
                    >
                      {{ package?.name }}
                      <span
                        class="corner-triangle"
                        [ngStyle]="{
                          'border-top-color': getColorForPlans1(
                            package?.published,
                            package?.restrictedAccess
                          )
                        }"
                      ></span>
                      <span
                        class="position-absolute"
                        style="top: 12px; right: 10px"
                      >
                        <i
                          class="fa"
                          [ngClass]="
                            isCollapsedBulk[package?.id]
                              ? 'bi-chevron-down'
                              : 'bi-chevron-down'
                          "
                          title="{{
                            getTextForTooltip1(
                              package?.published,
                              package?.restrictedAccess
                            )
                          }}"
                        ></i>
                      </span>
                    </h6>
                    <!-- <div
                      class="position-absolute"
                      style="top: 15px; left: 10px; bottom: -39px"
                    >
                      <div
                        *ngIf="
                          role === 'ADMINISTRATOR' &&
                          package?.groups?.length >= 1 &&
                          package?.name != undefined &&
                          package?.name != ''
                        "
                        title="{{
                          getTextForTooltip1(
                            package?.published,
                            package?.restrictedAccess
                          )
                        }}"
                        [ngStyle]="{
                          'border-color': getColorForPlans1(
                            package?.published,
                            package?.restrictedAccess
                          )
                        }"
                        class="outer my-auto col-2"
                        data-bs-toggle=""
                      >
                        <span
                          class="inner"
                          [ngStyle]="{
                            background: getColorForPlans1(
                              package?.published,
                              package?.restrictedAccess
                            )
                          }"
                        ></span>
                      </div>
                    </div> -->
                  </div>
                </div>
                <div
                  class="form-group package"
                  style="margin-top: -2px"
                  *ngIf="package?.groups?.length >= 1"
                >
                  <div
                    [ngClass]="
                      isCollapsedBulk[package?.id] ? 'package-groups1' : ''
                    "
                    *ngFor="let group of package?.groups; let j = index"
                    title=""
                  >
                    <div
                      class="price"
                      *ngIf="group && group != null && group?.published == true"
                    >
                      <div
                        class="header overflow-ellipsis1 panel-title collapsed"
                        [attr.data-bs-target]="'#collapsethreeBulk' + group.id"
                        data-bs-toggle="collapse"
                        aria-expanded="false"
                        aria-controls="collapsethreeBulk{{ group.id }}"
                        title="{{ group.name }}"
                        *ngIf="
                          group &&
                          group.subGroups &&
                          group.subGroups.length > 0 &&
                          package?.groups?.length > 1
                        "
                      >
                        {{ group.name }}
                      </div>
                    </div>

                    <div
                      class="planbody"
                      *ngIf="
                        group && group.subGroups && group.subGroups.length > 0
                      "
                    >
                      <div
                        *ngFor="let subgroup of group.subGroups; let k = index"
                      >
                        <div
                          *ngIf="subgroup"
                          id="collapsethreeBulk{{
                            package?.groups?.length > 1
                              ? subgroup.parentId
                              : package?.id
                          }}"
                          class="accordion-collapse collapse hide"
                        >
                          <div style="display: flex; flex-direction: column">
                            <div
                              class="featuutrebody1 row ps-3"
                              [style.background-color]="
                                subgroup.backgroundColor
                                  ? subgroup.backgroundColor
                                  : defaultColor
                              "
                              *ngIf="subgroup"
                            >
                              <!-- <div class="col-1">
                                <div
                                  *ngIf="
                                    role === 'ADMINISTRATOR' &&
                                    package?.groups?.length >= 1
                                  "
                                  title="{{
                                    getTextForTooltip(
                                      subgroup.published?.data[0],
                                      subgroup.restricted
                                    )
                                  }}"
                                  [ngStyle]="{
                                    'border-color': getColorForPlans(
                                      subgroup.published?.data[0],
                                      subgroup.restricted
                                    )
                                  }"
                                  class="outer my-auto col-2"
                                  data-bs-toggle=""
                                >
                                  <span
                                    class="inner"
                                    [ngStyle]="{
                                      background: getColorForPlans(
                                        subgroup.published?.data[0],
                                        subgroup.restricted,
                                        subgroup.name
                                      )
                                    }"
                                  ></span>
                                </div>
                              </div> -->
                              <span
                                class="col-11 text-wrap"
                                style="padding: 0px"
                                >{{ subgroup.name }}
                                <span
                                  *ngIf="
                                    role === 'ADMINISTRATOR' &&
                                    package?.groups?.length >= 1
                                  "
                                  title="{{
                                    getTextForTooltip(
                                      subgroup.published?.data[0],
                                      subgroup.restricted
                                    )
                                  }}"
                                  class="corner-triangle"
                                  [ngStyle]="{
                                    'border-top-color': getColorForPlans1(
                                      subgroup.published?.data[0],
                                      subgroup.restricted
                                    )
                                  }"
                                ></span>
                                <span *ngIf="viewPlan" class="plan-count">
                                  <span
                                    >(
                                    <span
                                      style="font-weight: bold"
                                      title="Total Companies"
                                      data-taggle="tooltip"
                                    >
                                      <!-- {{ bulkMembersCount[subgroup?.id]?.count?.totalCount }} -->
                                      {{
                                        bulkPlanCounts[subgroup?.id]?.entries
                                          ?.length ?? 0
                                      }},
                                    </span>
                                    &nbsp;
                                    <span
                                      style="font-weight: bold"
                                      title="Total Headcount"
                                      data-taggle="tooltip"
                                    >
                                      {{
                                        bulkPlanCounts[subgroup?.id]
                                          ?.totalCount ?? 0
                                      }}
                                    </span>
                                    )</span
                                  >
                                </span>
                              </span>
                              <i
                                *ngIf="viewPlan"
                                class="fa fa-eye"
                                id="viewimg"
                                data-bs-toggle="modal"
                                data-bs-target="#bulkPlanList"
                                (click)="viewPlanDetails(subgroup, '')"
                              ></i>
                              <!-- *ngIf="!viewPlan" -->
                              <input
                                *ngIf="!viewPlan && subgroup?.settings?.productListApplicable==false && subgroup?.settings?.productList?.length==0"
                                type="checkbox"
                                id="plancheckkboxbulk{{ subgroup?.id }}"
                                class="col-1 plancheckkboxbulk{{
                                  package?.id
                                }} plancv largerCheckbox"
                                attr.data="{{ package?.allowMultiple }}##{{
                                  subgroup.disallowedPlanLevels
                                }}##{{ package?.id }}##{{
                                  subgroup.parentId
                                }}##{{ subgroup?.id }}##{{ package?.name }}##{{
                                  subgroup.name
                                }}##{{ subgroup }}##{{ subgroup.ordering }}"
                                (change)="
                                  onCheckboxChangeBulkPlns(
                                    $event,
                                    package?.allowMultiple,
                                    subgroup.disallowedPlanLevels,
                                    package?.id,
                                    subgroup?.id,
                                    package?.name,
                                    subgroup.name,
                                    subgroup,
                                    subgroup.ordering,
                                    group.id,
                                    group.name,
                                    i,
                                    j,
                                    k
                                  )
                                "
                              />

                              <div
                                id="{{ subgroup?.id }}"
                                *ngIf="checkboxCheck[subgroup?.id]"
                                class="countblock p-0 my-1"
                              >
                                <span for="Corporation" class="Corporation mb-1">{{
                                  lang?.Head_Count ?? "Head Count"
                                }}</span>
                                <div class="d-flex flex-column my-1">
                                  <div class="mb-2 d-flex align-items-start" *ngFor="let bulkPlan of groupedBulkPlans[subgroup?.id?.toString()]; let z = index">
                                    <input
                                      class="headcountbox headerCount"
                                      [(ngModel)]="bulkPlan.quantity"
                                      (keypress)="preventNegative($event)"
                                      (input)="preventNonNumeric($event)"
                                      min="0"
                                      max="100000"
                                      (change)="
                                        updateTotal(
                                          j,
                                          $event,
                                          subgroup,
                                          subgroup.settings?.requiredCustomersCount,
                                          bulkPlan
                                        )
                                      "
                                      disabled
                                    />
                                    <div class="d-flex">
                                      <div class="d-flex">
                                    <i 
                                      class="bi bi-info-circle px-1"
                                      id="tooltip"
                                      data-bs-toggle="tooltip"
                                    >
                                      <table class="tooltiptext ignoreTable">
                                        <tbody>
                                          <tr class="ignoreTable">
                                            <td 
                                              class="d-block" 
                                              style="padding: 2px 6px" 
                                            >Status: {{(bulkPlan?.status ?? 'Draft')}} </td>
                                            <td 
                                              class="d-block" 
                                              style="padding: 2px 6px" 
                                              *ngIf="bulkPlan?.backdatedActivationDate ?? bulkPlan?.activationDate"
                                            >Plan Start Date: {{(bulkPlan?.backdatedActivationDate ?? bulkPlan?.activationDate) |date}} </td>
                                            <td 
                                              class="d-block" 
                                              style="padding: 2px 6px"
                                              *ngIf="bulkPlan?.backdatedCancellationDate ?? bulkPlan?.cancellationDate ?? bulkPlan?.terminationDate"
                                            >Plan End Date: {{(bulkPlan?.backdatedCancellationDate ?? bulkPlan?.cancellationDate ?? bulkPlan?.terminationDate) | date}}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      </i>
                                      <div>
                                        <span
                                          class="d-block" 
                                          *ngIf="bulkPlan?.backdatedCancellationDate ?? bulkPlan?.cancellationDate ?? bulkPlan?.terminationDate"
                                        >Expiring on {{(bulkPlan?.backdatedCancellationDate ?? bulkPlan?.cancellationDate ?? bulkPlan?.terminationDate) | date}}</span>
                                        <span
                                          class="d-block" 
                                          *ngIf="isFutureActivationDate(bulkPlan)"
                                        >
                                          Activating on {{ (bulkPlan?.activationDate ?? bulkPlan?.effectiveDate) | date }}
                                        </span>
                                      </div>
                                    </div>
                                    <div class="ms-2">
                                    <i
                                      *ngIf="groupedBulkPlans[subgroup?.id?.toString()]?.length>0?groupedBulkPlans[subgroup?.id?.toString()]?.length-1 == z:true"
                                      style="color:rgb(56, 76, 159)"
                                      class="fa fa-pencil-square-o icon mx-1"
                                      data-bs-target="#edit-headcount"
                                      title="Edit"
                                      data-bs-toggle="modal"
                                      (click)="updateBulkHeadCount(bulkPlan, subgroup)"
                                    ></i>
                                    <i
                                      *ngIf="groupedBulkPlans[subgroup?.id?.toString()]?.length>0?groupedBulkPlans[subgroup?.id?.toString()]?.length-1 == z:true"
                                      style="color:red"
                                      class="bi bi-trash-fill mx-1"
                                      title="Terminate"
                                      data-bs-target="#terminate-bulkplan"
                                      data-bs-toggle="modal"
                                      (click)="terminateBulkPlan(bulkPlan)"
                                    ></i>
                                    </div>
                                    </div>
                                  </div>

                                  <div *ngIf="!groupedBulkPlans[subgroup?.id?.toString()]">
                                    <input
                                      class="headcountbox headerCount mx-1"
                                      [(ngModel)]="showHeadCount[subgroup?.id]"
                                      (keypress)="preventNegative($event)"
                                      (input)="preventNonNumeric($event)"
                                      (change)="
                                        updateTotal(
                                          j,
                                          $event,
                                          subgroup,
                                          subgroup.settings?.requiredCustomersCount
                                        )
                                      "
                                      disabled
                                    />
                                    <!-- <i 
                                      class="bi bi-info-circle px-1"
                                      id="tooltip"
                                      data-bs-toggle="tooltip"
                                    >
                                      <table class="tooltiptext ignoreTable">
                                        <tbody>
                                          <tr class="ignoreTable">
                                            <td 
                                              class="d-block" 
                                              style="padding: 2px 6px" 
                                              *ngIf="subgroup?.backdatedActivationDate ?? subgroup?.activationDate"
                                            >Plan Start Date: {{(subgroup?.backdatedActivationDate ?? subgroup?.activationDate) |date}} </td>
                                            <td 
                                              class="d-block" 
                                              style="padding: 2px 6px"
                                              *ngIf="subgroup?.backdatedCancellationDate ?? subgroup?.cancellationDate ?? subgroup?.terminationDate"
                                            >Plan End Date: {{(subgroup?.backdatedCancellationDate ?? subgroup?.cancellationDate ?? subgroup?.terminationDate) | date}}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      </i>
                                    <i
                                      style="color:rgb(56, 76, 159)"
                                      class="bi bi-pencil-fill"
                                      data-bs-target="#edit-headcount"
                                      data-bs-toggle="modal"
                                      (click)="updateBulkHeadCount(subgroup, subgroup)"
                                      ></i>&nbsp;&nbsp;
                                      <i
                                      style="color:red"
                                      class="bi bi-x-lg"
                                      data-bs-target="#terminate-bulkplan"
                                      data-bs-toggle="modal"
                                      (click)="terminateBulkPlan(subgroup)"
                                    ></i>                                     -->
                                    <div class="d-flex">
                                      <div class="d-flex">
                                    <i 
                                      class="bi bi-info-circle px-1"
                                      id="tooltip"
                                      data-bs-toggle="tooltip"
                                    >
                                      <table class="tooltiptext ignoreTable">
                                        <tbody>
                                          <tr class="ignoreTable">
                                            <td 
                                              class="d-block" 
                                              style="padding: 2px 6px" 
                                            >Status: {{(bulkPlan?.status ?? 'Draft')}} </td>
                                            <td 
                                              class="d-block" 
                                              style="padding: 2px 6px" 
                                              *ngIf="bulkPlan?.backdatedActivationDate ?? bulkPlan?.activationDate"
                                            >Plan Start Date: {{(bulkPlan?.backdatedActivationDate ?? bulkPlan?.activationDate) |date}} </td>
                                            <td 
                                              class="d-block" 
                                              style="padding: 2px 6px"
                                              *ngIf="bulkPlan?.backdatedCancellationDate ?? bulkPlan?.cancellationDate ?? bulkPlan?.terminationDate"
                                            >Plan End Date: {{(bulkPlan?.backdatedCancellationDate ?? bulkPlan?.cancellationDate ?? bulkPlan?.terminationDate) | date}}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      </i>
                                      <div>
                                        <span
                                          class="d-block" 
                                          *ngIf="bulkPlan?.backdatedCancellationDate ?? bulkPlan?.cancellationDate ?? bulkPlan?.terminationDate"
                                        >Expiring on {{(bulkPlan?.backdatedCancellationDate ?? bulkPlan?.cancellationDate ?? bulkPlan?.terminationDate) | date}}</span>
                                        <span
                                          class="d-block" 
                                          *ngIf="isFutureActivationDate(bulkPlan)"
                                        >
                                          Activating on {{ (bulkPlan?.activationDate ?? bulkPlan?.effectiveDate) | date }}
                                        </span>
                                      </div>
                                    </div>
                                    <div class="ms-2">
                                    <i
                                      *ngIf="groupedBulkPlans[subgroup?.id?.toString()]?.length>0?groupedBulkPlans[subgroup?.id?.toString()]?.length-1 == z:true"
                                      style="color:rgb(56, 76, 159)"
                                      class="fa fa-pencil-square-o icon mx-1"
                                      data-bs-target="#edit-headcount"
                                      title="Edit"
                                      data-bs-toggle="modal"
                                      (click)="updateBulkHeadCount(bulkPlan, subgroup)"
                                    ></i>
                                    <i
                                      *ngIf="groupedBulkPlans[subgroup?.id?.toString()]?.length>0?groupedBulkPlans[subgroup?.id?.toString()]?.length-1 == z:true"
                                      style="color:red"
                                      class="bi bi-trash-fill mx-1"
                                      title="Terminate"
                                      data-bs-target="#terminate-bulkplan"
                                      data-bs-toggle="modal"
                                      (click)="terminateBulkPlan(bulkPlan)"
                                    ></i>
                                    </div>
                                    </div>
                                  </div>
                                </div>
                                
                                <label
                                  for="Corporation"
                                  class="Corporation"
                                  *ngIf="
                                    !showHeadCount[subgroup?.id] ||
                                    showHeadCount[subgroup?.id] <= 0
                                  "
                                  style="color: red"
                                  >{{ lang.Please_enter_head_count }}
                                </label>

                                <div
                                  class="text-left"
                                  *ngIf="false && 
                                    checkboxCheck[subgroup?.id] &&
                                    showinputboxvalue[subgroup?.id] &&
                                    (showHeadCount[subgroup?.id] ||
                                      showHeadCount[subgroup?.id] > 0)
                                  "
                                >
                                  <label
                                    for="DownloadButton"
                                    id="uploadButtonExcel"
                                    title="Download Template"
                                    data-taggle="tooltip"
                                    (click)="
                                      exportAsXLSX(
                                        subgroup?.id,
                                        subgroup.settings.memberDetailsKeysDB
                                      )
                                    "
                                    class="Cursorpointer"
                                  >
                                    <img
                                      src="../../../assets/img/download-template.png"
                                      style="width: 100px; height: 30px"
                                    /> </label
                                  >&nbsp;
                                  <label
                                    for="uploadButton-{{ subgroup?.id }}"
                                    id="uploadButtonExcel-{{ subgroup?.id }}"
                                    title="Upload Employee/Entity List"
                                    data-taggle="tooltip"
                                    class="Cursorpointer"
                                  >
                                    <img
                                      src="../../../assets/img/upload-employee-list.png"
                                      style="width: 100px; height: 30px"
                                    />
                                    <input
                                      id="uploadButton-{{ subgroup?.id }}"
                                      #myFileInput
                                      style="display: none"
                                      type="file"
                                      (input)="
                                        onFileChangeExcel(
                                          $event,
                                          subgroup?.id,
                                          subgroup.settings.memberDetailsKeysDB
                                        )
                                      "
                                    />
                                  </label>
                                  &nbsp;
                                  <i
                                    class="fa fa-eye"
                                    title="view"
                                    aria-hidden="true"
                                    data-bs-toggle="modal"
                                    (click)="editEmployees(subgroup?.id)"
                                  ></i>
                                </div>
                              </div>

                              <!-- *ngIf="false" -->
                              <div
                                *ngIf="!viewPlan && subgroup?.settings?.productListApplicable==true && subgroup?.settings?.productList?.length>0"
                                class="executiveplansselection d-flex flex-column"
                              >
                                <ng-container
                                  *ngFor="
                                    let coverage of subgroup?.settings?.productList
                                    let a = index;
                                    trackBy: trackByCoverageIdBulk
                                  "
                                >
                                  <label
                                    class="radio-inline executiveplans mt-1"
                                  >
                                    <input
                                      type="checkbox"
                                      name="executiveplans{{ coverage?.productId }}"
                                      id="{{'executiveplanssbulk' + coverage?.productId}}"
                                      style="vertical-align: bottom"
                                      attr.data="{{
                                        package?.allowMultiple
                                      }}##{{
                                        subgroup.disallowedPlanLevels
                                      }}##{{ package?.id }}##{{
                                        subgroup.parentId
                                      }}##{{ subgroup.id }}##{{
                                        package?.name
                                      }}##{{ subgroup.name }}##{{
                                        subgroup
                                      }}##{{ subgroup.ordering }}##{{ i }}##{{
                                        j
                                      }}##{{ k }}"
                                      (click)="
                                        executiveBulkplansCoverage(
                                          $event,
                                          i,
                                          j,
                                          k,
                                          coverage.productId,
                                          subgroup?.settings?.requiredCustomersCount,
                                          subgroup
                                        )
                                      "
                                    />
                                    {{
                                      coverage?.name
                                    }}
                                  </label>

                                  <div
                                    id="{{ coverage?.id }}"
                                    *ngIf="showHeadCountProduct[coverage?.productId] && false"
                                    class="countblock p-0 my-1"
                                  >
                                    <span for="Corporation" class="Corporation">{{
                                      lang?.Head_Count ?? "Head Count"
                                    }}</span>
                                    <input
                                      type="number"
                                      class="headcountbox headerCount mx-1"
                                      [(ngModel)]="showHeadCountProduct[coverage?.productId]"
                                      (keypress)="preventNegative($event)"
                                      (input)="preventNonNumeric($event)"
                                      min="0"
                                      max="100000"
                                      (change)="
                                        updateTotalProduct(
                                          j,
                                          $event,
                                          subgroup,
                                          subgroup.settings?.requiredCustomersCount,
                                          coverage.productId
                                        )
                                      "
                                    />
                                    <label
                                      for="Corporation"
                                      class="Corporation"
                                      *ngIf="
                                        !showHeadCountProduct[coverage?.productId] ||
                                        showHeadCountProduct[coverage?.productId] <= 0
                                      "
                                      style="color: red"
                                      >{{ lang.Please_enter_head_count }}
                                    </label>
                                    &nbsp;

                                    <div
                                      class="text-left"
                                      *ngIf="
                                        (subgroup?.settings?.showMemberDetailsDB ?? currentPlan?.showMemberDetails) &&
                                        (showHeadCountProduct[coverage?.productId] ||
                                          showHeadCountProduct[coverage?.productId] > 0)
                                      "
                                    >
                                      <label
                                        for="DownloadButton"
                                        id="uploadButtonExcel"
                                        title="Download Template"
                                        data-taggle="tooltip"
                                        (click)="
                                          exportAsXLSXProducts(
                                            subgroup?.id,
                                            subgroup.settings.memberDetailsKeysDB
                                          )
                                        "
                                        class="Cursorpointer"
                                      >
                                        <img
                                          src="../../../assets/img/download-template.png"
                                          style="width: 100px; height: 30px"
                                        /> </label
                                      >&nbsp;
                                      <label
                                        for="uploadButton-{{ coverage?.id }}"
                                        id="uploadButtonExcel-{{ coverage?.id }}"
                                        title="Upload Employee/Entity List"
                                        data-taggle="tooltip"
                                        class="Cursorpointer"
                                      >
                                        <img
                                          src="../../../assets/img/upload-employee-list.png"
                                          style="width: 100px; height: 30px"
                                        />
                                        <input
                                          id="uploadButton-{{ coverage?.id }}"
                                          #myFileInput
                                          style="display: none"
                                          type="file"
                                          (input)="
                                            onFileChangeExcel(
                                              $event,
                                              subgroup?.id,
                                              subgroup.settings?.memberDetailsKeysDB
                                            )
                                          "
                                        />
                                      </label>
                                      &nbsp;
                                      <i
                                        class="fa fa-eye"
                                        title="view"
                                        aria-hidden="true"
                                        data-bs-toggle="modal"
                                        (click)="editEmployees(subgroup?.id)"
                                      ></i>
                                    </div>
                                  </div>

                                  <div *ngIf="true">
                                    <div class="d-flex align-items-start" *ngFor="let bulkPlan of groupedBulkPlans[subgroup?.id?.toString()]; let z = index">
                                      <input
                                        *ngIf="coverage?.productId?.toString() == bulkPlan?.productId?.toString() && showHeadCountProduct[coverage?.productId] > 0"
                                        type="number"
                                        class="headcountbox headerCount mx-1 mb-2 mt-1"
                                        [(ngModel)]="showHeadCountProduct[coverage?.productId]"
                                        (keypress)="preventNegative($event)"
                                        (input)="preventNonNumeric($event)"
                                        style="margin-right: 5px;"
                                        min="0"
                                        max="100000"
                                        (change)="
                                          updateTotalProduct(
                                            j,
                                            $event,
                                            subgroup,
                                            subgroup.settings?.requiredCustomersCount,
                                            coverage.productId
                                          )
                                        "
                                        disabled
                                      />
                                      <div class="d-flex" *ngIf="coverage?.productId?.toString()==bulkPlan?.productId?.toString() && showHeadCountProduct[coverage?.productId] > 0">
                                        <div class="d-flex">
                                          <i 
                                            class="bi bi-info-circle px-1"
                                            id="tooltip"
                                            data-bs-toggle="tooltip"
                                          >
                                            <table class="tooltiptext ignoreTable">
                                              <tbody>
                                                <tr class="ignoreTable">
                                                  <td 
                                                    class="d-block" 
                                                    style="padding: 2px 6px" 
                                                  >Status: {{(bulkPlan?.status ?? 'Draft')}} </td>
                                                  <td 
                                                    class="d-block" 
                                                    style="padding: 2px 6px" 
                                                    *ngIf="bulkPlan?.backdatedActivationDate ?? bulkPlan?.activationDate"
                                                  >Plan Start Date: {{(bulkPlan?.backdatedActivationDate ?? bulkPlan?.activationDate) |date}} </td>
                                                  <td 
                                                    class="d-block" 
                                                    style="padding: 2px 6px"
                                                    *ngIf="bulkPlan?.backdatedCancellationDate ?? bulkPlan?.cancellationDate ?? bulkPlan?.terminationDate"
                                                  >Plan End Date: {{(bulkPlan?.backdatedCancellationDate ?? bulkPlan?.cancellationDate ?? bulkPlan?.terminationDate) | date}}</td>
                                                </tr>
                                              </tbody>
                                            </table>
                                            </i>
                                            <div>
                                              <span
                                                class="d-block" 
                                                *ngIf="bulkPlan?.backdatedCancellationDate ?? bulkPlan?.cancellationDate ?? bulkPlan?.terminationDate"
                                              >Expiring on {{(bulkPlan?.backdatedCancellationDate ?? bulkPlan?.cancellationDate ?? bulkPlan?.terminationDate) | date}}</span>
                                              <span
                                                class="d-block" 
                                                *ngIf="isFutureActivationDate(bulkPlan)"
                                              >
                                                Activating on {{ (bulkPlan?.activationDate ?? bulkPlan?.effectiveDate) | date }}
                                              </span>
                                            </div>
                                          </div>
                                          <div class="ms-2">
                                          <i
                                            *ngIf="groupedBulkPlans[subgroup?.id?.toString()][coverage?.productId]?.length>0?groupedBulkPlans[subgroup?.id?.toString()][coverage?.productId]?.length-1 == z:true"
                                            style="color:rgb(56, 76, 159)"
                                            class="fa fa-pencil-square-o icon mx-1"
                                            data-bs-target="#edit-headcount"
                                            title="Edit"
                                            data-bs-toggle="modal"
                                            (click)="updateBulkHeadCount(bulkPlan, subgroup)"
                                          ></i>
                                          <i
                                            *ngIf="groupedBulkPlans[subgroup?.id?.toString()][coverage?.productId]?.length>0?groupedBulkPlans[subgroup?.id?.toString()][coverage?.productId]?.length-1 == z:true"
                                            style="color:red"
                                            class="bi bi-trash-fill mx-1"
                                            title="Terminate"
                                            data-bs-target="#terminate-bulkplan"
                                            data-bs-toggle="modal"
                                            (click)="terminateBulkPlan(bulkPlan,coverage?.productId)"
                                          ></i>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </ng-container>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <i
            *ngIf="isScrollable"
            class="chevron chevron-right fa bi-chevron-right right--chevron"
            (click)="scrollRight()"
          ></i>
        </div>
      </div>

      <div class="main-div">
        <h6 class="subheading py-2">
          {{ "Core Plans (100% premium paid directly by employer)" }}
        </h6>
        <div class="scroll-container position-relative">
          <i
            *ngIf="isScrollableCore"
            class="chevron chevron-left fa bi-chevron-left left--chevron"
            (click)="scrollLeftCore()"
          ></i>

          <div
            #corePlans
            class="core-plans d-flex align-items-start overflow-x-auto"
            style="min-width: 100%"
          >
            <div
              class="packageWrapper plansscreen"
              style="background: white"
              *ngFor="let package of plansBlock1; let i = index"
            >
              <div
                class="planheadingwrap"
                style="padding-left: 6px"
                *ngIf="
                  package?.groups?.length >= 1 &&
                  showPackageName(package?.groups, 'core')
                "
              >
                <div class="d-flex position-relative flex-column">
                  <h6
                    class="planheading ps-3"
                    id="plancheckkcollapseone{{ package?.id }}"
                    [attr.data-bs-target]="'#collapseone' + package?.id"
                    data-bs-toggle="collapse"
                    [attr.aria-expanded]="!isCollapsed[package?.id]"
                    aria-controls="collapseone{{ package?.id }}"
                    (click)="toggleCollapsee(package?.id, package)"
                    id="parent1"
                  >
                    {{ package?.name }}
                    <span
                      class="corner-triangle"
                      [ngStyle]="{
                        'border-top-color': getColorForPlans1(
                          package?.published,
                          package?.restrictedAccess
                        )
                      }"
                      title="{{
                        getTextForTooltip1(
                          package?.published,
                          package?.restrictedAccess
                        )
                      }}"
                    ></span>
                    <span
                      class="position-absolute"
                      style="top: 12px; right: 10px"
                    >
                      <i
                        class="fa"
                        [ngClass]="
                          isCollapsed[package?.id]
                            ? 'bi-chevron-down'
                            : 'bi-chevron-down'
                        "
                      ></i>
                    </span>
                  </h6>
                  <!-- <div class="position-absolute" style="top: 15px; left: 10px">
                    <div
                      *ngIf="
                        role === 'ADMINISTRATOR' &&
                        package?.groups?.length >= 1 &&
                        showPackageName(package?.groups, 'core') &&
                        package?.published == true
                      "
                      title="{{
                        getTextForTooltip1(
                          package?.published,
                          package?.restrictedAccess
                        )
                      }}"
                      [ngStyle]="{
                        'border-color': getColorForPlans1(
                          package?.published,
                          package?.restrictedAccess
                        )
                      }"
                      class="outer my-auto col-2"
                      data-bs-toggle=""
                    >
                      <span
                        class="inner"
                        [ngStyle]="{
                          background: getColorForPlans1(
                            package?.published,
                            package?.restrictedAccess
                          )
                        }"
                      ></span>
                    </div>
                  </div> -->
                  <div
                    class="form-group package"
                    *ngIf="!isCollapsed[package?.id]"
                  >
                    <div
                      [ngClass]="
                        !showGroupName(group, 'core') ? '' : 'package-groups1'
                      "
                      *ngFor="let group of package?.groups; let j = index"
                      title=""
                    >
                      <div class="price" id="myGroup">
                        <div
                          *ngIf="
                            package?.groups?.length > 1 &&
                            showGroupName(group, 'core')
                          "
                          class="header overflow-ellipsis1 panel-title d-flex justify-content-start align-items-center ps-3"
                          [style.background-color]="
                            group.backgroundColor
                              ? group.backgroundColor
                              : defaultColor
                          "
                          id="plancheckkcollapseone{{ group.id }}"
                          [attr.data-bs-target]="'#collapseone' + group.id"
                          data-bs-toggle="collapse"
                          [attr.aria-expanded]="!isExpanded[group.id]"
                          aria-controls="collapseone{{ group.id }}"
                          title="{{ group.name }}"
                          (click)="toggleGroup(group.id)"
                        >
                          {{ group.name }}
                          <i
                            class="bi"
                            [ngClass]="
                              isExpanded[group.id]
                                ? 'bi-chevron-down'
                                : 'bi-chevron-down'
                            "
                            style="
                              position: absolute;
                              right: 10px;
                              top: 8px;
                              color: white;
                            "
                          ></i>
                        </div>
                      </div>
                      <div
                        class="planbody"
                        *ngIf="group.subGroups && group.subGroups.length > 0"
                      >
                        <div
                          *ngFor="
                            let subgroup of group.subGroups;
                            let k = index
                          "
                        >
                          <div
                            *ngIf="subgroup && subgroup?.settings?.core"
                            id="collapseone{{
                              package?.groups?.length > 1
                                ? subgroup.parentId
                                : package?.id
                            }}"
                            class="accordion-collapse collapse show"
                          >
                            <div
                              class="featuutrebody"
                              [style.background-color]="
                                subgroup.backgroundColor
                                  ? subgroup.backgroundColor
                                  : defaultColor
                              "
                            >
                              <div class="row ps-3 mx-0">
                                <!-- <div class="col-1">
                                  <div
                                    *ngIf="
                                      role === 'ADMINISTRATOR' &&
                                      package?.groups?.length > 1
                                    "
                                    title="{{
                                      getTextForTooltip(
                                        subgroup.published?.data[0],
                                        subgroup.restricted
                                      )
                                    }}"
                                    [ngStyle]="{
                                      'border-color': getColorForPlans(
                                        subgroup.published?.data[0],
                                        subgroup.restricted
                                      )
                                    }"
                                    class="outer my-auto col-2"
                                    data-bs-toggle=""
                                  >
                                    <span
                                      class="inner"
                                      [ngStyle]="{
                                        background: getColorForPlans(
                                          subgroup.published?.data[0],
                                          subgroup.restricted,
                                          subgroup.name
                                        )
                                      }"
                                    ></span>
                                  </div>
                                </div> -->

                                <!-- <span>(
                                  <span style="font-weight: bold;">
                                    {{ membersCount[subgroup?.id]?.count?.paidByCompany }}
                                  </span>
                                  <span v-if="membersCount[subgroup?.id]?.coverageCounts?.paidByCompany?.SINGLE">
                                    , <span style="color: blue;">
                                      {{ membersCount[subgroup?.id]?.coverageCounts?.paidByCompany?.SINGLE }}
                                    </span>
                                  </span>
                                  <span v-if="membersCount[subgroup?.id]?.coverageCounts?.paidByCompany?.COUPLE">
                                    , <span style="color: green;">
                                      {{ membersCount[subgroup?.id]?.coverageCounts?.paidByCompany?.COUPLE }}
                                    </span>
                                  </span>
                                  <span v-if="membersCount[subgroup?.id]?.coverageCounts?.paidByCompany?.FAMILY">
                                    , <span style="color: purple;">
                                      {{ membersCount[subgroup?.id]?.coverageCounts?.paidByCompany?.FAMILY }}
                                    </span>
                                  </span>
                                )</span> -->

                                <span
                                  class="col-11"
                                  style="
                                    text-align: left;
                                    padding: 0px;
                                    color: black;
                                  "
                                >
                                  {{ subgroup.name }}&nbsp;
                                  <span *ngIf="viewPlan" class="plan-count">
                                    <!-- <span>(</span>
                                  <span>{{membersCount[subgroup?.id]?.count?.paidByCompany}}</span>
                                  <span>
                                    {{", "+ (membersCount[subgroup?.id]?.coverageCounts?.paidByCompany?.SINGLE??'0')}}
                                  </span>
                                  <span>
                                    {{", "+ (membersCount[subgroup?.id]?.coverageCounts?.paidByCompany?.COUPLE??'0')}}
                                  </span>
                                  <span>
                                    {{", "+ (membersCount[subgroup?.id]?.coverageCounts?.paidByCompany?.FAMILY??'0')}}
                                  </span>
                                  <span>)</span> -->
                                    <span
                                      >(
                                      <span
                                        style="font-weight: bold"
                                        title="Total"
                                        data-taggle="tooltip"
                                      >
                                        {{
                                          membersCount[subgroup?.id]?.count
                                            ?.paidByCompany
                                        }}
                                      </span>

                                      <span
                                        *ngIf="
                                          getCompanyPaidCoverage(
                                            subgroup?.id,
                                            'SINGLE'
                                          )
                                        "
                                        title="Single"
                                        data-taggle="tooltip"
                                      >
                                        ,
                                        <span style="color: blue">
                                          {{
                                            membersCount[subgroup?.id]
                                              ?.coverageCounts?.paidByCompany
                                              ?.SINGLE ?? 0
                                          }}
                                        </span>
                                      </span>

                                      <span
                                        *ngIf="
                                          getCompanyPaidCoverage(
                                            subgroup?.id,
                                            'COUPLE'
                                          )
                                        "
                                        title="Couple"
                                        data-taggle="tooltip"
                                      >
                                        ,
                                        <span style="color: green">
                                          {{
                                            membersCount[subgroup?.id]
                                              ?.coverageCounts?.paidByCompany
                                              ?.COUPLE ?? 0
                                          }}
                                        </span>
                                      </span>

                                      <span
                                        *ngIf="
                                          getCompanyPaidCoverage(
                                            subgroup?.id,
                                            'FAMILY'
                                          )
                                        "
                                        title="Family"
                                        data-taggle="tooltip"
                                      >
                                        ,
                                        <span style="color: purple">
                                          {{
                                            membersCount[subgroup?.id]
                                              ?.coverageCounts?.paidByCompany
                                              ?.FAMILY ?? 0
                                          }}
                                        </span>
                                      </span>
                                      )</span
                                    >
                                  </span>
                                  <span
                                    *ngIf="
                                      role == 'ADMINISTRATOR' &&
                                      package?.groups?.length >= 1
                                    "
                                    title="{{
                                      getTextForTooltip(
                                        subgroup.published?.data[0],
                                        subgroup.restricted
                                      )
                                    }}"
                                    class="corner-triangle"
                                    [ngStyle]="{
                                      'border-top-color': getColorForPlans1(
                                        subgroup.published?.data[0],
                                        subgroup.restricted
                                      )
                                    }"
                                  ></span>
                                </span>

                                <i
                                  *ngIf="viewPlan"
                                  class="fa fa-eye"
                                  id="viewimg"
                                  data-bs-toggle="modal"
                                  data-bs-target="#viewPlanDetails"
                                  (click)="
                                    viewPlanDetails(subgroup, 'paidByCompany')
                                  "
                                ></i>
                                <input
                                  *ngIf="!viewPlan"
                                  type="checkbox"
                                  id="plancheckk{{ subgroup.id }}"
                                  class="col-1 plancheckkbox{{
                                    package?.id
                                  }} plancv largerCheckbox block1"
                                  attr.data="{{ package?.allowMultiple }}##{{
                                    subgroup.disallowedPlanLevels
                                  }}##{{ package?.id }}##{{
                                    subgroup.parentId
                                  }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                    subgroup.name
                                  }}##{{ subgroup }}##{{
                                    subgroup.ordering
                                  }}##{{ i }}##{{ j }}##{{ k }}"
                                  (change)="
                                    onCheckboxChange1(
                                      $event,
                                      package?.allowMultiple,
                                      subgroup.disallowedPlanLevels,
                                      package?.id,
                                      subgroup.id,
                                      package?.name,
                                      subgroup.name,
                                      subgroup,
                                      subgroup.ordering,
                                      group.id,
                                      group.name,
                                      i,
                                      j,
                                      k
                                    )
                                  "
                                  [checked]="checkedSubgroups[subgroup.id]"
                                  [(ngModel)]="subgroup.checked"
                                />
                              </div>
                              <div
                                class="executiveplansselection ps-3"
                                *ngIf="showCoverages(subgroup) && !viewPlan"
                              >
                                <!-- <label class="radio-inline executiveplans">
                                  <input
                                    type="checkbox"
                                    name="executiveplans{{ subgroup.id }}"
                                    id="executiveplansssingle{{ subgroup.id }}"
                                    style="vertical-align: bottom"
                                    (click)="
                                      executiveplansCoverage(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    "
                                  />
                                  {{ lang?.Single }}
                                </label>
                                <label class="radio-inline executiveplans">
                                  <input
                                    type="checkbox"
                                    name="executiveplans{{ subgroup.id }}"
                                    id="executiveplansscouple{{ subgroup.id }}"
                                    style="vertical-align: bottom"
                                    (click)="
                                      executiveplansCoverage(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    "
                                  />
                                  {{ lang?.Couple }}
                                </label>
                                <label class="radio-inline executiveplans">
                                  <input
                                    type="checkbox"
                                    name="executiveplans{{ subgroup.id }}"
                                    id="executiveplanssfamily{{ subgroup.id }}"
                                    style="vertical-align: bottom"
                                    (click)="
                                      executiveplansCoverage(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    "
                                  />
                                  {{ lang?.Family }}
                                </label> -->
                                <ng-container
                                  *ngFor="
                                    let coverage of companyPaidCoveragePlanLevels[
                                      subgroup.id
                                    ];
                                    let a = index;
                                    trackBy: trackByCoverageIdCore
                                  "
                                >
                                  <label
                                    class="radio-inline executiveplans"
                                    *ngIf="
                                      coverage?.label == 'Single' ||
                                      coverage?.label == 'Couple' ||
                                      coverage?.label == 'Family'
                                    "
                                  >
                                    <input
                                      type="checkbox"
                                      name="executiveplans{{ subgroup.id }}"
                                      id="{{
                                        coverage?.label == 'Single'
                                          ? 'executiveplansssingle' +
                                            subgroup.id
                                          : coverage?.label == 'Couple'
                                          ? 'executiveplansscouple' +
                                            subgroup.id
                                          : 'executiveplanssfamily' +
                                            subgroup.id
                                      }}"
                                      style="vertical-align: bottom"
                                      attr.data="{{
                                        package?.allowMultiple
                                      }}##{{
                                        subgroup.disallowedPlanLevels
                                      }}##{{ package?.id }}##{{
                                        subgroup.parentId
                                      }}##{{ subgroup.id }}##{{
                                        package?.name
                                      }}##{{ subgroup.name }}##{{
                                        subgroup
                                      }}##{{ subgroup.ordering }}##{{ i }}##{{
                                        j
                                      }}##{{ k }}"
                                      (click)="
                                        executiveplansCoverage(
                                          $event,
                                          i,
                                          j,
                                          k,
                                          subgroup.id
                                        )
                                      "
                                      [disabled]="
                                        disabledByMap[subgroup?.id?.toString()]
                                      "
                                      [checked]="
                                        coreSelectedCoverages[
                                          subgroup.id
                                        ].includes(coverage.label)
                                      "
                                    />
                                    {{
                                      subgroup.id == 31 &&
                                      coverage?.label == "Single"
                                        ? "Individual"
                                        : coverage?.label
                                    }}
                                  </label>
                                </ng-container>
                              </div>
                            </div>
                            <!-- <ng-container *ngIf="role == 'ADMINISTRATOR'">
                              <div
                                class="planCoverage"
                                *ngIf="
                                  subgroup.checked &&
                                  plansCoveragecheckboxCheck[subgroup.id]
                                "
                              >
                                <select
                                  class="form-control"
                                  id="Province"
                                  placeholder="Province"
                                  [(ngModel)]="getPlanCoverage[subgroup.id]"
                                >
                                  <option value="" [disabled]="true" selected>
                                    {{ lang?.Select ?? 'Select' }}
                                  </option>
                                  <option
                                    *ngFor="
                                      let coverage of companyPaidCoveragePlanLevels[
                                        subgroup.id
                                      ]
                                    "
                                    [value]="coverage.value"
                                  >
                                    {{ coverage.label }}
                                  </option>
                                </select>
                              </div>
                            </ng-container> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <i
            *ngIf="isScrollableCore"
            class="chevron chevron-right fa bi-chevron-right right--chevron"
            (click)="scrollRightCore()"
          ></i>
        </div>
      </div>

      <div class="main-div">
        <!-- style="border: 1px solid lightgray;" -->
        <div class="row header-title p-0 subheading">
          <h6 class="my-auto col-6 py-2">
            {{
              lang?.Upgrade_Plans_Premium_difference_paid_by_employee_through_payroll_deduction ??
                "Upgrade Plans (Premium difference paid by employee through payroll deduction)"
            }}
          </h6>
          <div class="col-4" style="font-size: 15px" *ngIf="!viewPlan">
            {{ lang?.Enabled ?? "Enabled?" }}
            <input
              class=""
              type="radio"
              name="upgradeplans"
              id="upgradeplanstrue"
              #upgradeplanstrue
              value="true"
              (click)="upgradeplans($event)"
            />
            <label
              class="form-check-label"
              for="workinghoursno"
              class="upgradeplans"
              >&nbsp;{{ lang?.Yes ?? "Yes" }}</label
            >&nbsp;&nbsp;
            <input
              class=""
              type="radio"
              name="upgradeplans"
              id="upgradeplansfalse"
              #upgradeplansfalse
              value="false"
              (click)="upgradeplans($event)"
              checked
            />
            <label
              class="form-check-label"
              for="workinghoursno"
              class="upgradeplans"
              >&nbsp;{{ lang?.No ?? "No" }}</label
            >
          </div>
        </div>

        <div class="scroll-container position-relative mt-1">
          <i
            *ngIf="isScrollableUpgrade"
            class="chevron chevron-left fa bi-chevron-left left--chevron"
            (click)="scrollLeftCore()"
          ></i>

          <div
            #upgradePlans
            class="upgrade-plans d-flex align-items-start"
            *ngIf="upgradeplansselection || viewPlan"
          >
            <div
              class="packageWrapper block2packagewrapper plansscreen2 w-auto"
              *ngFor="let package of plansresblack2; let i = index"
            >
              <!-- showPackageName(package?.groups, 'upgrade') -->
              <div
                class="planheadingwrap d-flex align-items-start"
                style="padding-left: 6px"
                *ngIf="
                  package?.groups?.length >= 1 &&
                  hasVisibleUpgradeCoverageForPackage(package)
                "
              >
                <div class="d-flex position-relative flex-column">
                  <h6
                    class="planheading ps-3"
                    [attr.data-bs-target]="'#collapsetwo' + package?.id"
                    data-bs-toggle="collapse"
                    aria-expanded="false"
                    aria-controls="collapsetwo{{ package?.id }}"
                    (click)="toggleCollapseeTwo(package?.id)"
                    id="parent2"
                  >
                    {{ package?.name }}
                    <span
                      class="corner-triangle"
                      [ngStyle]="{
                        'border-top-color': getColorForPlans1(
                          package?.published,
                          package?.restrictedAccess
                        )
                      }"
                      title="{{
                        getTextForTooltip1(
                          package?.published,
                          package?.restrictedAccess
                        )
                      }}"
                    ></span>
                    <span
                      class="position-absolute"
                      style="top: 12px; right: 10px"
                    >
                      <i
                        class="fa"
                        [ngClass]="
                          isCollapsedTwo[package?.id]
                            ? 'bi-chevron-down'
                            : 'bi-chevron-down'
                        "
                      ></i>
                    </span>
                  </h6>
                  <!-- <div class="position-absolute" style="top: 15px; left: 10px">
                    <div
                      *ngIf="
                        role === 'ADMINISTRATOR' &&
                        package?.groups?.length >= 1 &&
                        showPackageName(package?.groups, 'upgrade')
                      "
                      title="{{
                        getTextForTooltip1(
                          package?.published,
                          package?.restrictedAccess
                        )
                      }}"
                      [ngStyle]="{
                        'border-color': getColorForPlans1(
                          package?.published,
                          package?.restrictedAccess
                        )
                      }"
                      class="outer my-auto col-2"
                      data-bs-toggle=""
                    >
                      <span
                        class="inner"
                        [ngStyle]="{
                          background: getColorForPlans1(
                            package?.published,
                            package?.restrictedAccess
                          )
                        }"
                      ></span>
                    </div>
                  </div> -->
                  <div
                    class="form-group package"
                    *ngIf="!isCollapsedTwo[package?.id]"
                  >
                    <div
                      [ngClass]="
                        showGroupName(group, 'upgrade') &&
                        hasVisibleUpgradeCoverage(group)
                          ? 'package-groups1'
                          : ''
                      "
                      *ngFor="let group of package?.groups; let j = index"
                      title=""
                    >
                      <div
                        class="price"
                        *ngIf="
                          group &&
                          group != null &&
                          showGroupName(group, 'upgrade') &&
                          hasVisibleUpgradeCoverage(group)
                        "
                      >
                        <div
                          class="header overflow-ellipsis1 panel-title d-flex justify-content-start align-items-center ps-3"
                          [style.background-color]="
                            group.backgroundColor
                              ? group.backgroundColor
                              : defaultColor
                          "
                          [attr.data-bs-target]="'#collapsetwo' + group.id"
                          data-bs-toggle="collapse"
                          [attr.aria-expanded]="!isExpandedTwo[package?.id]"
                          (click)="toggleGroupTwo(group.id)"
                          aria-controls="collapsetwo{{ group.id }}"
                          title="{{ group.name }}"
                          *ngIf="
                            group &&
                            group.subGroups &&
                            group.subGroups.length > 0 &&
                            package?.groups?.length > 1
                          "
                        >
                          {{ group.name }}
                          <span
                            class="position-absolute"
                            style="top: 8px; right: 10px"
                          >
                            <i
                              class="fa"
                              style="color: white"
                              [ngClass]="
                                isExpandedTwo[package?.id]
                                  ? 'bi-chevron-down'
                                  : 'bi-chevron-down'
                              "
                            ></i>
                          </span>
                        </div>
                      </div>

                      <div
                        class="planbody"
                        *ngIf="
                          group && group.subGroups && group.subGroups.length > 0
                        "
                      >
                        <div
                          *ngFor="
                            let subgroup of group.subGroups;
                            let k = index
                          "
                        >
                          <div
                            *ngIf="subgroup"
                            id="collapsetwo{{
                              package?.groups?.length > 1
                                ? subgroup.parentId
                                : package?.id
                            }}"
                            class="accordion-collapse collapse show"
                          >
                            <div
                              class="featuutrebody row ps-3 position-relative"
                              [style.background-color]="
                                subgroup.backgroundColor
                                  ? subgroup.backgroundColor
                                  : defaultColor
                              "
                              *ngIf="
                                subgroup &&
                                subgroup?.settings?.upgrade &&
                                (companyPaidCoveragePlanLevels[subgroup.id]
                                  ?.length > 0
                                  ? upgradeCoverages[subgroup.id]?.length > 0
                                  : true)
                              "
                            >
                              <!-- <div class="col-2">
                                <div
                                  *ngIf="
                                    role === 'ADMINISTRATOR' &&
                                    package?.groups?.length >= 1
                                  "
                                  title="{{
                                    getTextForTooltip(
                                      subgroup.published?.data[0],
                                      subgroup.restricted
                                    )
                                  }}"
                                  [ngStyle]="{
                                    'border-color': getColorForPlans(
                                      subgroup.published?.data[0],
                                      subgroup.restricted
                                    )
                                  }"
                                  class="outer my-auto col-2"
                                  data-bs-toggle=""
                                >
                                  <span
                                    class="inner"
                                    [ngStyle]="{
                                      background: getColorForPlans(
                                        subgroup.published?.data[0],
                                        subgroup.restricted,
                                        subgroup.name
                                      )
                                    }"
                                  ></span>
                                </div>
                              </div> -->
                              <span
                                class="col-11"
                                style="
                                  text-align: left;
                                  padding: 0px;
                                  color: black;
                                "
                                >{{ subgroup.name }}&nbsp;
                                <span *ngIf="viewPlan" class="plan-count">
                                  <!-- <span>(</span>
                                <span>{{membersCount[subgroup?.id]?.count?.coveredByCompany}}</span>
                                <span>
                                  {{", "+ (membersCount[subgroup?.id]?.coverageCounts?.coveredByCompany?.SINGLE??'0')}}
                                </span>
                                <span>
                                  {{", "+ (membersCount[subgroup?.id]?.coverageCounts?.coveredByCompany?.COUPLE??'0')}}
                                </span>
                                <span>
                                  {{", "+ (membersCount[subgroup?.id]?.coverageCounts?.coveredByCompany?.FAMILY??'0')}}
                                </span>
                                <span>)</span> -->
                                  <span
                                    >(
                                    <span
                                      style="font-weight: bold"
                                      title="Total"
                                      data-taggle="tooltip"
                                    >
                                      {{
                                        membersCount[subgroup?.id]?.count
                                          ?.coveredByCompany
                                      }}
                                    </span>

                                    <span
                                      *ngIf="
                                        getCompanyPaidCoverage(
                                          subgroup?.id,
                                          'SINGLE'
                                        )
                                      "
                                      title="Single"
                                      data-taggle="tooltip"
                                    >
                                      ,
                                      <span style="color: blue">
                                        {{
                                          membersCount[subgroup?.id]
                                            ?.coverageCounts?.coveredByCompany
                                            ?.SINGLE ?? 0
                                        }}
                                      </span>
                                    </span>

                                    <span
                                      *ngIf="
                                        getCompanyPaidCoverage(
                                          subgroup?.id,
                                          'COUPLE'
                                        )
                                      "
                                      title="Couple"
                                      data-taggle="tooltip"
                                    >
                                      ,
                                      <span style="color: green">
                                        {{
                                          membersCount[subgroup?.id]
                                            ?.coverageCounts?.coveredByCompany
                                            ?.COUPLE ?? 0
                                        }}
                                      </span>
                                    </span>

                                    <span
                                      *ngIf="
                                        getCompanyPaidCoverage(
                                          subgroup?.id,
                                          'FAMILY'
                                        )
                                      "
                                      title="Family"
                                      data-taggle="tooltip"
                                    >
                                      ,
                                      <span style="color: purple">
                                        {{
                                          membersCount[subgroup?.id]
                                            ?.coverageCounts?.coveredByCompany
                                            ?.FAMILY ?? 0
                                        }}
                                      </span>
                                    </span>
                                    )</span
                                  >
                                </span>
                                <!-- <span
                                  *ngIf="
                                    role === 'ADMINISTRATOR' &&
                                    package?.groups?.length >= 1
                                  "
                                  title="{{
                                    getTextForTooltip(
                                      subgroup.published?.data[0],
                                      subgroup.restricted
                                    )
                                  }}"
                                  class="corner-triangle"
                                  [ngStyle]="{
                                    'border-top-color': getColorForPlans1(
                                      subgroup.published?.data[0],
                                      subgroup.restricted
                                    )
                                  }"
                                ></span> -->
                                <span
                                  *ngIf="role === 'ADMINISTRATOR'"
                                  class="corner-triangle"
                                  title="{{
                                    getTextForTooltip(
                                      subgroup.published?.data[0],
                                      subgroup.restricted
                                    )
                                  }}"
                                  [ngStyle]="{
                                    'border-top-color': getColorForPlans1(
                                      subgroup.published?.data[0],
                                      subgroup.restricted
                                    )
                                  }"
                                ></span>
                              </span>

                              <i
                                *ngIf="viewPlan"
                                class="fa fa-eye"
                                id="viewimg"
                                data-bs-toggle="modal"
                                data-bs-target="#viewPlanDetails"
                                (click)="
                                  viewPlanDetails(subgroup, 'coveredByCompany')
                                "
                              ></i>
                              <input
                                *ngIf="!viewPlan"
                                type="checkbox"
                                id="plancheckk2Upgrade{{ subgroup.id }}"
                                class="col-1 plancheckkbox2{{
                                  package?.id
                                }} plancheckkbox2{{
                                  subgroup.id
                                }} plancv largerCheckbox block2"
                                attr.data="{{ package?.allowMultiple }}##{{
                                  subgroup.disallowedPlanLevels
                                }}##{{ package?.id }}##{{
                                  subgroup.parentId
                                }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                  subgroup.name
                                }}##{{ subgroup }}##{{ subgroup.ordering }}##{{
                                  i
                                }}##{{ j }}##{{ k }}"
                                (change)="
                                  onCheckboxChange2(
                                    $event,
                                    package?.allowMultiple,
                                    subgroup.disallowedPlanLevels,
                                    package?.id,
                                    subgroup.id,
                                    package?.name,
                                    subgroup.name,
                                    subgroup,
                                    subgroup.ordering,
                                    group.id,
                                    group.name,
                                    i,
                                    j,
                                    k
                                  )
                                "
                                [checked]="checkedSubgroups2[subgroup.id]"
                                [(ngModel)]="subgroup.checked"
                                [disabled]="disabledByMap2[subgroup?.id]"
                              />

                              <!-- (subgroup?.coverage == undefined ||
                                subgroup?.coverage?.trim() == '') && -->
                              <div
                                class="executiveplansselection"
                                *ngIf="
                                  showCoverages(subgroup) &&
                                  !viewPlan &&
                                  !allowInMultipleGroups.includes(subgroup.id)
                                "
                              >
                                <!-- <label class="radio-inline executiveplans">
                                  <input
                                    type="checkbox"
                                    name="executiveplansblock2{{ subgroup.id }}"
                                    id="executiveplanssblock2single{{
                                      subgroup.id
                                    }}"
                                    style="vertical-align: bottom"
                                    (click)="
                                      executiveplansCoverage2(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    "
                                  />
                                  {{ lang.Single }}
                                </label>
                                <label class="radio-inline executiveplans">
                                  <input
                                    type="checkbox"
                                    name="executiveplansblock2{{ subgroup.id }}"
                                    id="executiveplanssblock2couple{{
                                      subgroup.id
                                    }}"
                                    style="vertical-align: bottom"
                                    (click)="
                                      executiveplansCoverage2(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    "
                                  />
                                  {{ lang.Couple }}
                                </label>
                                <label class="radio-inline executiveplans">
                                  <input
                                    type="checkbox"
                                    name="executiveplansblock2{{ subgroup.id }}"
                                    id="executiveplanssblock2family{{
                                      subgroup.id
                                    }}"
                                    style="vertical-align: bottom"
                                    (click)="
                                      executiveplansCoverage2(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    "
                                  />
                                  {{ lang.Family }}
                                </label> -->
                                <!-- let coverage of companyPaidCoveragePlanLevels[ -->
                                <ng-container
                                  *ngFor="
                                    let coverage of upgradeCoverages[
                                      subgroup.id
                                    ];
                                    let a = index;
                                    trackBy: trackByCoverageIdUpgrade
                                  "
                                >
                                  <label
                                    class="radio-inline executiveplans"
                                    *ngIf="
                                      coverage?.label == 'Single' ||
                                      coverage?.label == 'Couple' ||
                                      coverage?.label == 'Family'
                                    "
                                  >
                                    <input
                                      type="checkbox"
                                      name="executiveplans{{ subgroup.id }}"
                                      id="{{
                                        coverage?.label == 'Single'
                                          ? 'executiveplanssblock2single' +
                                            subgroup.id
                                          : coverage?.label == 'Couple'
                                          ? 'executiveplanssblock2couple' +
                                            subgroup.id
                                          : 'executiveplanssblock2family' +
                                            subgroup.id
                                      }}"
                                      style="vertical-align: bottom"
                                      (click)="
                                        executiveplansCoverage2(
                                          $event,
                                          i,
                                          j,
                                          k,
                                          subgroup.id
                                        )
                                      "
                                      [disabled]="
                                        disabledByMap2[subgroup?.id]?.size > 0
                                      "
                                      [checked]="
                                        upgradeSelectedCoverages[
                                          subgroup.id
                                        ].includes(coverage.label)
                                      "
                                    />
                                    {{
                                      subgroup.id == 31 &&
                                      coverage?.label == "Single"
                                        ? "Individual"
                                        : coverage?.label
                                    }}
                                  </label>
                                </ng-container>
                              </div>

                              <div
                                class="executiveplansselection"
                                *ngIf="
                                  subgroup.coverage == '001' &&
                                  showCoverages(subgroup) &&
                                  !viewPlan &&
                                  false
                                "
                              >
                                <!-- <label class="radio-inline executiveplans">
                                  <input
                                    type="checkbox"
                                    name="executiveplansblock2{{ subgroup.id }}"
                                    id="executiveplanssblock2couple{{
                                      subgroup.id
                                    }}"
                                    style="vertical-align: bottom"
                                    (click)="
                                      executiveplansCoverage2(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    "
                                  />
                                  {{ lang.Couple }}
                                </label>
                                <label class="radio-inline executiveplans">
                                  <input
                                    type="checkbox"
                                    name="executiveplansblock2{{ subgroup.id }}"
                                    id="executiveplanssblock2family{{
                                      subgroup.id
                                    }}"
                                    style="vertical-align: bottom"
                                    (click)="
                                      executiveplansCoverage2(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    "
                                  />
                                  {{ lang.Family }}
                                </label> -->
                                <ng-container
                                  *ngFor="
                                    let coverage of companyPaidCoveragePlanLevels[
                                      subgroup.id
                                    ];
                                    let a = index
                                  "
                                >
                                  <label
                                    class="radio-inline executiveplans"
                                    *ngIf="
                                      coverage?.label == 'Couple' ||
                                      coverage?.label == 'Family'
                                    "
                                  >
                                    <input
                                      type="checkbox"
                                      name="executiveplans{{ subgroup.id }}"
                                      id="{{
                                        coverage?.label == 'Couple'
                                          ? 'executiveplanssblock2couple' +
                                            subgroup.id
                                          : 'executiveplanssblock2family' +
                                            subgroup.id
                                      }}"
                                      style="vertical-align: bottom"
                                      (click)="
                                        executiveplansCoverage2(
                                          $event,
                                          i,
                                          j,
                                          k,
                                          subgroup.id
                                        )
                                      "
                                    />
                                    {{ coverage?.label }}
                                  </label>
                                </ng-container>
                              </div>
                              <div
                                class="executiveplansselection"
                                *ngIf="
                                  subgroup.coverage == '010' &&
                                  showCoverages(subgroup) &&
                                  !viewPlan &&
                                  false
                                "
                              >
                                <!-- <label class="radio-inline executiveplans">
                                  <input
                                    type="checkbox"
                                    name="executiveplansblock2{{ subgroup.id }}"
                                    id="executiveplanssblock2family{{
                                      subgroup.id
                                    }}"
                                    style="vertical-align: bottom"
                                    (click)="
                                      executiveplansCoverage2(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    "
                                  />
                                  {{ lang.Family }}
                                </label> -->
                                <ng-container
                                  *ngFor="
                                    let coverage of companyPaidCoveragePlanLevels[
                                      subgroup.id
                                    ];
                                    let a = index
                                  "
                                >
                                  <label
                                    class="radio-inline executiveplans"
                                    *ngIf="coverage?.label == 'Family'"
                                  >
                                    <input
                                      type="checkbox"
                                      name="executiveplans{{ subgroup.id }}"
                                      id="executiveplanssblock2family{{
                                        subgroup.id
                                      }}"
                                      style="vertical-align: bottom"
                                      (click)="
                                        executiveplansCoverage2(
                                          $event,
                                          i,
                                          j,
                                          k,
                                          subgroup.id
                                        )
                                      "
                                    />
                                    {{ coverage?.label }}
                                  </label>
                                </ng-container>
                              </div>
                              <div
                                class="executiveplansselection"
                                *ngIf="
                                  subgroup.coverage == '011' &&
                                  showCoverages(subgroup) &&
                                  !viewPlan &&
                                  false
                                "
                              >
                                <!-- <label class="radio-inline executiveplans">
                                  <input
                                    type="checkbox"
                                    name="executiveplansblock2{{ subgroup.id }}"
                                    id="executiveplanssblock2family{{
                                      subgroup.id
                                    }}"
                                    style="vertical-align: bottom"
                                    (click)="
                                      executiveplansCoverage2(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    "
                                  />
                                  {{ lang.Family }}
                                </label> -->
                                <ng-container
                                  *ngFor="
                                    let coverage of companyPaidCoveragePlanLevels[
                                      subgroup.id
                                    ];
                                    let a = index
                                  "
                                >
                                  <label
                                    class="radio-inline executiveplans"
                                    *ngIf="a > 0 && coverage?.label == 'Family'"
                                  >
                                    <input
                                      type="checkbox"
                                      name="executiveplans{{ subgroup.id }}"
                                      id="executiveplanssblock2family{{
                                        subgroup.id
                                      }}"
                                      style="vertical-align: bottom"
                                      (click)="
                                        executiveplansCoverage2(
                                          $event,
                                          i,
                                          j,
                                          k,
                                          subgroup.id
                                        )
                                      "
                                    />
                                    {{ coverage?.label }}
                                  </label>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <i
            *ngIf="isScrollableUpgrade"
            class="chevron chevron-right fa bi-chevron-right right--chevron"
            (click)="scrollRightCore()"
          ></i>
        </div>
      </div>

      <div class="main-div">
        <!-- style="border: 1px solid lightgray;" -->
        <div class="row header-title p-0 subheading">
          <h6 class="my-auto col-6 py-2">
            {{ "Voluntary Plans (100% Premium paid directly by employee)" }}
          </h6>
          <div class="col-4" style="font-size: 15px" *ngIf="!viewPlan">
            {{ lang?.Enabled ?? "Enabled?" }}
            <input
              class=""
              type="radio"
              name="employeepurchase"
              id="employeepurchasetrue"
              #employeepurchasetrue
              value="true"
              (click)="planpurchase($event)"
            />
            <label
              class="form-check-label"
              for="employeepurchasetrue"
              class="employeepurchase"
              >&nbsp;{{ lang?.Yes ?? "Yes" }}</label
            >&nbsp;&nbsp;
            <input
              class=""
              type="radio"
              name="employeepurchase"
              id="employeepurchasefalse"
              #employeepurchasefalse
              value="false"
              (click)="planpurchase($event)"
              checked
            />
            <label
              class="form-check-label"
              for="employeepurchasefalse"
              class="employeepurchase"
              >&nbsp;{{ lang?.No ?? "No" }}</label
            >
          </div>
        </div>

        <div class="scroll-container position-relative mt-1">
          <i
            *ngIf="isScrollableVoluntary"
            class="chevron chevron-left fa bi-chevron-left left--chevron"
            (click)="scrollLeftVoluntary()"
          ></i>

          <div
            #voluntaryPlans
            class="voluntary-plans d-flex overflow-x-auto align-items-start"
            *ngIf="employeeplanpurchase || viewPlan"
          >
            <div
              class="packageWrapper block3packagewrapper plansscreen3 w-auto"
              *ngFor="let package of plansresblack3; let i = index"
            >
              <!-- showPackageName(package?.groups, 'voluntary') -->
              <div
                class="planheadingwrap"
                style="padding-left: 6px"
                *ngIf="
                  package?.groups?.length >= 1 &&
                  hasVisibleVoluntaryCoverageForPackage(package)
                "
              >
                <div class="d-flex position-relative flex-column">
                  <h6
                    class="planheading ps-3"
                    [attr.data-bs-target]="'#collapsethree' + package?.id"
                    data-bs-toggle="collapse"
                    aria-expanded="false"
                    aria-controls="collapsethree{{ package?.id }}"
                    (click)="toggleCollapseeThree(package?.id)"
                    id="parent3"
                  >
                    {{ package?.name }}
                    <span
                      class="corner-triangle"
                      [ngStyle]="{
                        'border-top-color': getColorForPlans1(
                          package?.published,
                          package?.restrictedAccess
                        )
                      }"
                      title="{{
                        getTextForTooltip1(
                          package?.published,
                          package?.restrictedAccess
                        )
                      }}"
                    ></span>
                    <span
                      class="position-absolute"
                      style="top: 12px; right: 10px"
                    >
                      <i
                        class="fa"
                        [ngClass]="
                          isCollapsedThree[package?.id]
                            ? 'bi-chevron-down'
                            : 'bi-chevron-down'
                        "
                      ></i>
                    </span>
                  </h6>
                  <!-- <div class="position-absolute" style="top: 15px; left: 10px">
                    <div
                      *ngIf="
                        role === 'ADMINISTRATOR' &&
                        package?.groups?.length >= 1 &&
                        showPackageName(package?.groups, 'voluntary')
                      "
                      title="{{
                        getTextForTooltip1(
                          package?.published,
                          package?.restrictedAccess
                        )
                      }}"
                      [ngStyle]="{
                        'border-color': getColorForPlans1(
                          package?.published,
                          package?.restrictedAccess
                        )
                      }"
                      class="outer my-auto col-2"
                      data-bs-toggle=""
                    >
                      <span
                        class="inner"
                        [ngStyle]="{
                          background: getColorForPlans1(
                            package?.published,
                            package?.restrictedAccess
                          )
                        }"
                      ></span>
                    </div>
                  </div> -->
                  <div
                    class="form-group package"
                    *ngIf="!isCollapsedThree[package?.id]"
                  >
                    <div
                      [ngClass]="
                        showGroupName(group, 'voluntary') &&
                        hasVisibleVoluntaryCoverage(group)
                          ? 'package-groups1'
                          : ''
                      "
                      *ngFor="let group of package?.groups; let j = index"
                      title=""
                    >
                      <div
                        class="price"
                        *ngIf="
                          group &&
                          group != null &&
                          showGroupName(group, 'voluntary') &&
                          hasVisibleVoluntaryCoverage(group)
                        "
                      >
                        <div
                          class="header overflow-ellipsis1 panel-title d-flex justify-content-start align-items-center ps-3"
                          [attr.data-bs-target]="'#collapsethree' + group.id"
                          data-bs-toggle="collapse"
                          [attr.aria-expanded]="!isExpandedThree[group?.id]"
                          (click)="toggleGroupThree(group.id)"
                          aria-controls="collapsethree{{ group.id }}"
                          title="{{ group.name }}"
                          [style.background-color]="
                            group.backgroundColor
                              ? group.backgroundColor
                              : defaultColor
                          "
                          *ngIf="
                            group &&
                            group.subGroups &&
                            group.subGroups.length > 0 &&
                            package?.groups?.length > 1
                          "
                        >
                          {{ group.name }}
                          <span
                            class="position-absolute"
                            style="top: 8px; right: 10px"
                          >
                            <i
                              class="fa"
                              [ngClass]="
                                isExpandedThree[package?.id]
                                  ? 'bi-chevron-down'
                                  : 'bi-chevron-down'
                              "
                            ></i>
                          </span>
                        </div>
                      </div>

                      <div
                        class="planbody"
                        *ngIf="
                          group && group.subGroups && group.subGroups.length > 0
                        "
                      >
                        <div
                          *ngFor="
                            let subgroup of group.subGroups;
                            let k = index
                          "
                        >
                          <div
                            *ngIf="
                              subgroup &&
                              subgroup?.settings?.voluntary &&
                              (companyPaidCoveragePlanLevels[subgroup.id]
                                ?.length > 0
                                ? voluntaryCoverages[subgroup.id]?.length > 0
                                : true)
                            "
                            id="collapsethree{{
                              package?.groups?.length > 1
                                ? subgroup.parentId
                                : package?.id
                            }}"
                            class="accordion-collapse collapse show"
                          >
                            <div
                              class="featuutrebody row ps-3"
                              [style.background-color]="
                                subgroup.backgroundColor
                                  ? subgroup.backgroundColor
                                  : defaultColor
                              "
                              *ngIf="subgroup"
                            >
                              <!-- <div class="col-3">
                                <div
                                  *ngIf="
                                    role === 'ADMINISTRATOR' &&
                                    package?.groups?.length >= 1
                                  "
                                  title="{{
                                    getTextForTooltip(
                                      subgroup.published?.data[0],
                                      subgroup.restricted
                                    )
                                  }}"
                                  [ngStyle]="{
                                    'border-color': getColorForPlans(
                                      subgroup.published?.data[0],
                                      subgroup.restricted
                                    )
                                  }"
                                  class="outer my-auto col-2"
                                  data-bs-toggle=""
                                >
                                  <span
                                    class="inner"
                                    [ngStyle]="{
                                      background: getColorForPlans(
                                        subgroup.published?.data[0],
                                        subgroup.restricted,
                                        subgroup.name
                                      )
                                    }"
                                  ></span>
                                </div>
                              </div> -->
                              <span
                                class="col-11"
                                style="
                                  text-align: left;
                                  padding: 0px;
                                  color: black;
                                "
                                >{{ subgroup.name }}&nbsp;
                                <span *ngIf="viewPlan" class="plan-count">
                                  <!-- <span>(</span>
                                <span>{{membersCount[subgroup?.id]?.count?.paidByEmployee}}</span>
                                <span>
                                  {{", "+ (membersCount[subgroup?.id]?.coverageCounts?.paidByEmployee?.SINGLE??'0')}}
                                </span>
                                <span>
                                  {{", "+ (membersCount[subgroup?.id]?.coverageCounts?.paidByEmployee?.COUPLE??'0')}}
                                </span>
                                <span>
                                  {{", "+ (membersCount[subgroup?.id]?.coverageCounts?.paidByEmployee?.FAMILY??'0')}}
                                </span>
                                <span>)</span> -->
                                  <span
                                    >(
                                    <span
                                      style="font-weight: bold"
                                      title="Total"
                                      data-taggle="tooltip"
                                    >
                                      {{
                                        membersCount[subgroup?.id]?.count
                                          ?.paidByEmployee
                                      }}
                                    </span>

                                    <span
                                      *ngIf="
                                        getCompanyPaidCoverage(
                                          subgroup?.id,
                                          'SINGLE'
                                        )
                                      "
                                      title="Single"
                                      data-taggle="tooltip"
                                    >
                                      ,
                                      <span style="color: blue">
                                        {{
                                          membersCount[subgroup?.id]
                                            ?.coverageCounts?.paidByEmployee
                                            ?.SINGLE ?? 0
                                        }}
                                      </span>
                                    </span>

                                    <span
                                      *ngIf="
                                        getCompanyPaidCoverage(
                                          subgroup?.id,
                                          'COUPLE'
                                        )
                                      "
                                      title="Couple"
                                      data-taggle="tooltip"
                                    >
                                      ,
                                      <span style="color: green">
                                        {{
                                          membersCount[subgroup?.id]
                                            ?.coverageCounts?.paidByEmployee
                                            ?.COUPLE ?? 0
                                        }}
                                      </span>
                                    </span>

                                    <span
                                      *ngIf="
                                        getCompanyPaidCoverage(
                                          subgroup?.id,
                                          'FAMILY'
                                        )
                                      "
                                      title="Family"
                                      data-taggle="tooltip"
                                    >
                                      ,
                                      <span style="color: purple">
                                        {{
                                          membersCount[subgroup?.id]
                                            ?.coverageCounts?.paidByEmployee
                                            ?.FAMILY ?? 0
                                        }}
                                      </span>
                                    </span>
                                    )</span
                                  >
                                </span>
                                <span
                                  *ngIf="
                                    role === 'ADMINISTRATOR' &&
                                    package?.groups?.length >= 1
                                  "
                                  title="{{
                                    getTextForTooltip(
                                      subgroup.published?.data[0],
                                      subgroup.restricted
                                    )
                                  }}"
                                  class="corner-triangle"
                                  [ngStyle]="{
                                    'border-top-color': getColorForPlans1(
                                      subgroup.published?.data[0],
                                      subgroup.restricted
                                    )
                                  }"
                                ></span>
                              </span>

                              <i
                                *ngIf="viewPlan"
                                class="fa fa-eye"
                                id="viewimg"
                                data-bs-toggle="modal"
                                data-bs-target="#viewPlanDetails"
                                (click)="
                                  viewPlanDetails(subgroup, 'paidByEmployee')
                                "
                              ></i>
                              <input
                                *ngIf="!viewPlan"
                                type="checkbox"
                                id="plancheckk3Voluntry{{ subgroup.id }}"
                                class="col-1 plancheckkbox3{{
                                  package?.id
                                }} plancv largerCheckbox"
                                attr.data="{{ package?.allowMultiple }}##{{
                                  subgroup.disallowedPlanLevels
                                }}##{{ package?.id }}##{{
                                  subgroup.parentId
                                }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                  subgroup.name
                                }}##{{ subgroup }}##{{ subgroup.ordering }}"
                                (change)="
                                  onCheckboxChange3(
                                    $event,
                                    package?.allowMultiple,
                                    subgroup.disallowedPlanLevels,
                                    package?.id,
                                    subgroup.id,
                                    package?.name,
                                    subgroup.name,
                                    subgroup,
                                    subgroup.ordering,
                                    group.id,
                                    group.name,
                                    i,
                                    j,
                                    k
                                  )
                                "
                                [checked]="checkedSubgroups3[subgroup.id]"
                                [(ngModel)]="subgroup.checked"
                                [disabled]="
                                  disabledByMap3[subgroup?.id]?.size > 0
                                "
                              />

                              <!-- (subgroup?.coverage == undefined ||
                                subgroup?.coverage?.trim() == '' || 
                                subgroup?.coverage?.trim() == '000') && -->
                              <div
                                *ngIf="showCoverages(subgroup) && !viewPlan"
                                class="p-0"
                              >
                                <div class="executiveplansselection">
                                  <!-- <label class="radio-inline executiveplans">
                                      <input
                                        type="checkbox"
                                        name="executiveplansblock3{{
                                          subgroup.id
                                        }}"
                                        id="executiveplanssblock3single{{
                                          subgroup.id
                                        }}"
                                        style="vertical-align: bottom"
                                        (click)="
                                          executiveplansCoverage3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        "
                                      />
                                      {{ lang.Single }}
                                    </label>
                                    <label class="radio-inline executiveplans">
                                      <input
                                        type="checkbox"
                                        name="executiveplansblock3{{
                                          subgroup.id
                                        }}"
                                        id="executiveplanssblock3couple{{
                                          subgroup.id
                                        }}"
                                        style="vertical-align: bottom"
                                        (click)="
                                          executiveplansCoverage3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        "
                                      />
                                      {{ lang.Couple }}
                                    </label>
                                    <label class="radio-inline executiveplans">
                                      <input
                                        type="checkbox"
                                        name="executiveplansblock3{{
                                          subgroup.id
                                        }}"
                                        id="executiveplanssblock3family{{
                                          subgroup.id
                                        }}"
                                        style="vertical-align: bottom"
                                        (click)="
                                          executiveplansCoverage3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        "
                                      />
                                      {{ lang.Family }}
                                    </label> -->
                                  <!-- let coverage of companyPaidCoveragePlanLevels[ -->
                                  <ng-container
                                    *ngFor="
                                      let coverage of voluntaryCoverages[
                                        subgroup.id
                                      ];
                                      let a = index;
                                      trackBy: trackByCoverageIdVoluntary
                                    "
                                  >
                                    <label
                                      class="radio-inline executiveplans"
                                      *ngIf="
                                        coverage?.label == 'Single' ||
                                        coverage?.label == 'Couple' ||
                                        coverage?.label == 'Family'
                                      "
                                    >
                                      <input
                                        type="checkbox"
                                        name="executiveplans{{ subgroup.id }}"
                                        id="{{
                                          coverage?.label == 'Single'
                                            ? 'executiveplanssblock3single' +
                                              subgroup.id
                                            : coverage?.label == 'Couple'
                                            ? 'executiveplanssblock3couple' +
                                              subgroup.id
                                            : 'executiveplanssblock3family' +
                                              subgroup.id
                                        }}"
                                        style="vertical-align: bottom"
                                        (click)="
                                          executiveplansCoverage3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        "
                                        [disabled]="
                                          disabledByMap3[subgroup?.id]
                                        "
                                        [checked]="
                                          voluntarySelectedCoverages[
                                            subgroup.id
                                          ].includes(coverage.label)
                                        "
                                      />
                                      {{
                                        subgroup.id == 31 &&
                                        coverage?.label == "Single"
                                          ? "Individual"
                                          : coverage?.label
                                      }}
                                    </label>
                                  </ng-container>
                                </div>
                              </div>

                              <div
                                *ngIf="
                                  subgroup.coverage == '001' &&
                                  showCoverages(subgroup) &&
                                  !viewPlan &&
                                  false
                                "
                                class="p-0"
                              >
                                <div class="executiveplansselection">
                                  <!-- <label class="radio-inline executiveplans">
                                      <input
                                        type="checkbox"
                                        name="executiveplansblock3{{
                                          subgroup.id
                                        }}"
                                        id="executiveplanssblock3couple{{
                                          subgroup.id
                                        }}"
                                        style="vertical-align: bottom"
                                        (click)="
                                          executiveplansCoverage3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        "
                                      />
                                      {{ lang.Couple }}
                                    </label>
                                    <label class="radio-inline executiveplans">
                                      <input
                                        type="checkbox"
                                        name="executiveplansblock3{{
                                          subgroup.id
                                        }}"
                                        id="executiveplanssblock3family{{
                                          subgroup.id
                                        }}"
                                        style="vertical-align: bottom"
                                        (click)="
                                          executiveplansCoverage3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        "
                                      />
                                      {{ lang.Family }}
                                    </label> -->
                                  <ng-container
                                    *ngFor="
                                      let coverage of companyPaidCoveragePlanLevels[
                                        subgroup.id
                                      ];
                                      let a = index
                                    "
                                  >
                                    <label
                                      class="radio-inline executiveplans"
                                      *ngIf="
                                        coverage?.label == 'Couple' ||
                                        coverage?.label == 'Family'
                                      "
                                    >
                                      <input
                                        type="checkbox"
                                        name="executiveplans{{ subgroup.id }}"
                                        id="{{
                                          coverage?.label == 'Couple'
                                            ? 'executiveplanssblock3couple' +
                                              subgroup.id
                                            : 'executiveplanssblock3family' +
                                              subgroup.id
                                        }}"
                                        style="vertical-align: bottom"
                                        (click)="
                                          executiveplansCoverage3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        "
                                      />
                                      {{ coverage?.label }}
                                    </label>
                                  </ng-container>
                                </div>
                              </div>
                              <div
                                *ngIf="
                                  subgroup.coverage == '010' &&
                                  showCoverages(subgroup) &&
                                  !viewPlan &&
                                  false
                                "
                                class="p-0"
                              >
                                <div class="executiveplansselection">
                                  <!-- <label class="radio-inline executiveplans">
                                      <input
                                        type="checkbox"
                                        name="executiveplansblock3{{
                                          subgroup.id
                                        }}"
                                        id="executiveplanssblock3family{{
                                          subgroup.id
                                        }}"
                                        style="vertical-align: bottom"
                                        (click)="
                                          executiveplansCoverage3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        "
                                      />
                                      {{ lang.Family }}
                                    </label> -->
                                  <ng-container
                                    *ngFor="
                                      let coverage of companyPaidCoveragePlanLevels[
                                        subgroup.id
                                      ];
                                      let a = index
                                    "
                                  >
                                    <label
                                      class="radio-inline executiveplans"
                                      *ngIf="coverage?.label == 'Family'"
                                    >
                                      <input
                                        type="checkbox"
                                        name="executiveplans{{ subgroup.id }}"
                                        id="executiveplanssblock3family{{
                                          subgroup.id
                                        }}"
                                        style="vertical-align: bottom"
                                        (click)="
                                          executiveplansCoverage3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        "
                                      />
                                      {{ coverage?.label }}
                                    </label>
                                  </ng-container>
                                </div>
                              </div>
                              <div
                                *ngIf="
                                  subgroup.coverage == '011' &&
                                  showCoverages(subgroup) &&
                                  !viewPlan &&
                                  false
                                "
                                class="p-0"
                              >
                                <div class="executiveplansselection">
                                  <!-- <label class="radio-inline executiveplans">
                                      <input
                                        type="checkbox"
                                        name="executiveplansblock3{{
                                          subgroup.id
                                        }}"
                                        id="executiveplanssblock3family{{
                                          subgroup.id
                                        }}"
                                        style="vertical-align: bottom"
                                        (click)="
                                          executiveplansCoverage3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        "
                                      />
                                      {{ lang.Family }}
                                    </label> -->
                                  <ng-container
                                    *ngFor="
                                      let coverage of companyPaidCoveragePlanLevels[
                                        subgroup.id
                                      ];
                                      let a = index
                                    "
                                  >
                                    <label
                                      class="radio-inline executiveplans"
                                      *ngIf="coverage?.label == 'Family'"
                                    >
                                      <input
                                        type="checkbox"
                                        name="executiveplans{{ subgroup.id }}"
                                        id="executiveplanssblock3family{{
                                          subgroup.id
                                        }}"
                                        style="vertical-align: bottom"
                                        (click)="
                                          executiveplansCoverage3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        "
                                      />
                                      {{ coverage?.label }}
                                    </label>
                                  </ng-container>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <i
            *ngIf="isScrollableVoluntary"
            class="chevron chevron-right fa bi-chevron-right right--chevron"
            (click)="scrollRightVoluntary()"
          ></i>
        </div>
      </div>
      <!-- <button class="saveAndNext" id="" type="button" (click)="submitplansInfo()">
        Save<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
      </button> -->
      <br />
      <br />

      <div
        class="modal fade"
        id="showBulkEmployeelist"
        data-backdrop="static"
        tabindex="-1"
      >
        <div
          class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
          id="modal-dialog"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">
                {{ lang?.Employee_List ?? "Employee List" }}
              </h6>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <table>
                <th>{{ lang?.First_Name ?? "First Name" }}</th>
                <th>{{ lang?.Last_Name ?? "Last Name" }}</th>
                <th>{{ lang?.Email ?? "Email" }}</th>
                <th>{{ lang?.Actions ?? "Actions" }}</th>
                <tr *ngFor="let item of employeeList; let i = index">
                  <ng-container
                    *ngIf="item.bulkPlanLevelId == selectedSubGrpId && item.productId != 0 ? item.productId == productListId : true"
                  >
                    <td>{{ item.firstName }}</td>
                    <td>{{ item.lastName }}</td>
                    <!-- <td *ngIf="item.email">
                      {{
                        item.email.length > 24
                          ? item.email.slice(0, 6) +
                            "..." +
                            item.email.slice(-6)
                          : item.email
                      }}
                    </td> -->
                    <td>{{item.email}}</td>
                    <td style="display: flex">
                      <a
                        class="btn btn-default deleteicon"
                        title="Delete"
                        data-toggle="tooltip"
                        (click)="deleteemployeeexcel(item, i, selectedSubGrpId)"
                        ><i class="bi bi-trash-fill"></i
                      ></a>
                    </td>
                  </ng-container>
                </tr>
              </table>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                id="closeaddadmin"
                (click)="closeEmployeeList()"
              >
                {{ lang?.Close ?? "Close" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- advisor -->
    <div
      class="main-div"
      *ngIf="selectedPlanCategory == planCategories[1] || isAdvisor"
    >
      <div class="scroll-container position-relative">
        <i
          *ngIf="isScrollableAdv"
          class="chevron chevron-left fa bi-chevron-left left--chevron"
          (click)="scrollLeftAdv()"
        ></i>

        <div
          #advPlans
          class="advisor-plans d-flex align-items-start overflow-x-auto"
        >
          <div
            *ngFor="let product of advisorPackages; let i = index"
            class="m-2"
          >
            <div
              class="display-center"
              *ngIf="!product.parents?.v || product.parents?.v?.length > 0"
            >
              <h6
                class="planheading panel-title ps-3"
                style="width: 345px; background: white"
              >
                <div
                  *ngIf="role === 'ADMINISTRATOR'"
                  title="{{
                    getTextForTooltip1(product.published, product.restrict)
                  }}"
                  class=""
                  data-bs-toggle=""
                >
                  <!-- <span
                    class="inner"
                    [ngStyle]="{
                      background: getColorForPlans1(
                        product.published,
                        product.restrict
                      )
                    }"
                  ></span> -->
                </div>
                <div class="my-auto mb-1 col-11">
                  <span class="my-auto mb-1 col-10"
                    >{{ product.name }}&nbsp;
                  </span>
                  <span
                    *ngIf="role == 'ADMINISTRATOR'"
                    class="corner-triangle"
                    [ngStyle]="{
                      'border-top-color': getColorForPlans1(
                        product?.published,
                        product?.restrict
                      )
                    }"
                  ></span>
                </div>
                <span class="my-auto col-1">
                  <input
                    *ngIf="!viewPlan"
                    type="checkbox"
                    id="package{{ product.id }}"
                    [disabled]="allplansArray[product.name]?.disabled === true"
                    [checked]="
                      allplansArray[product.name]?.packageCheckbox === true
                    "
                    (change)="toggleAllPlans(product.name, product.id, $event)"
                  />
                </span>
              </h6>
            </div>

            <div
              class="display-center mt-3 mb-4 flex-wrap package-groups1"
              *ngIf="!product.parents?.v || product.parents?.v?.length > 0"
            >
              <div
                class="price"
                *ngFor="let plans of product.parents | keyvalue; let k = index"
              >
                <div
                  class="header overflow-ellipsis1 panel-title d-flex justify-content-start align-items-center ps-3"
                  *ngIf="isParentsGreaterThanOne(product.parents)"
                  style="background-color: rgb(67, 111, 122)"
                >
                  <span class="m-0 col-11 text-center">
                    {{ plans.key }}
                  </span>
                  <span class="my-auto col-1">
                    <input
                      *ngIf="!viewPlan"
                      type="checkbox"
                      [disabled]="
                        allplansArray[product.name] &&
                        allplansArray[product.name][plans.key]?.disabled ===
                          true
                      "
                      [checked]="
                        allplansArray[product.name] &&
                        allplansArray[product.name][plans.key]?.checked === true
                      "
                      (change)="
                        planKeyCheckbox(
                          product.name,
                          plans.key,
                          plans.value[0]?.parentId,
                          $event
                        )
                      "
                    />
                  </span>
                </div>
                <div
                  [ngClass]="{
                    'display-center': !isParentsGreaterThanOne(product.parents),
                    'flex-wrap': !isParentsGreaterThanOne(product.parents)
                  }"
                >
                  <div *ngFor="let plan of plans.value">
                    <div class="featuutrebody row">
                      <div
                        [ngClass]="viewPlan ? 'col-11' : 'col-11'"
                        class="my-auto mb-1"
                        style="font-size: 12px; color: black"
                      >
                        <span style="text-wrap: wrap">{{ plan.name }}</span
                        >&nbsp;
                        <!-- <span *ngIf="viewPlan" class="plan-count">({{advisorsCount[plan.id]?.totalCount}})</span> -->
                        <span *ngIf="viewPlan" class="plan-count">
                          <span
                            >(
                            <span style="font-weight: bold">
                              <!-- {{ advisorsCount[plan?.id]?.totalCount }} -->
                              {{
                                (advisorsCount[plan?.id]?.coverageCounts
                                  ?.SINGLE ??
                                  0) +
                                  (advisorsCount[plan?.id]?.coverageCounts
                                    ?.COUPLE ??
                                    0) +
                                  (advisorsCount[plan?.id]?.coverageCounts
                                    ?.FAMILY ??
                                    0) >
                                0
                                  ? (advisorsCount[plan?.id]?.coverageCounts
                                      ?.SINGLE ??
                                      0) +
                                    (advisorsCount[plan?.id]?.coverageCounts
                                      ?.COUPLE ??
                                      0) +
                                    (advisorsCount[plan?.id]?.coverageCounts
                                      ?.FAMILY ??
                                      0)
                                  : advisorsCount[plan?.id]?.totalCount ?? 0
                              }}
                            </span>

                            <span
                              *ngIf="getCompanyPaidCoverage(plan?.id, 'SINGLE')"
                            >
                              ,
                              <span style="color: blue">
                                {{
                                  advisorsCount[plan?.id]?.coverageCounts
                                    ?.SINGLE ?? 0
                                }}
                              </span>
                            </span>

                            <span
                              *ngIf="getCompanyPaidCoverage(plan?.id, 'COUPLE')"
                            >
                              ,
                              <span style="color: green">
                                {{
                                  advisorsCount[plan?.id]?.coverageCounts
                                    ?.COUPLE ?? 0
                                }}
                              </span>
                            </span>

                            <span
                              *ngIf="getCompanyPaidCoverage(plan?.id, 'FAMILY')"
                            >
                              ,
                              <span style="color: purple">
                                {{
                                  advisorsCount[plan?.id]?.coverageCounts
                                    ?.FAMILY ?? 0
                                }}
                              </span>
                            </span>
                            )</span
                          >
                        </span>
                        <span
                          *ngIf="role == 'ADMINISTRATOR'"
                          class="corner-triangle"
                          [ngStyle]="{
                            'border-top-color': getColorForPlans2(
                              plan?.published,
                              plan?.restrict
                            )
                          }"
                        ></span>
                      </div>
                      <div class="my-auto col-1 p-0">
                        <i
                          *ngIf="viewPlan"
                          class="fa fa-eye"
                          id="viewimg"
                          data-bs-toggle="modal"
                          data-bs-target="#viewPlanDetails"
                          (click)="viewPlanDetailsAdv(plan)"
                        ></i>
                        <input
                          *ngIf="!viewPlan"
                          type="checkbox"
                          id="plancheckkbox{{ plans.id }}"
                          [checked]="
                            allplansArray[product.name] &&
                            allplansArray[product.name][plan.name]
                              ?.plancheckkbox === true
                          "
                          [disabled]="
                            allplansArray[product.name] &&
                            allplansArray[product.name][plan.name]?.disabled ===
                              true
                          "
                          (change)="
                            plancheckkbox(
                              product.name,
                              plans.key,
                              plans.value[0].parentId,
                              plan.name,
                              plan.id,
                              $event
                            )
                          "
                        />
                      </div>
                      <!-- <span 
                        *ngIf="role == 'ADMINISTRATOR'"
                        class="corner-triangle"
                        [ngStyle]="{
                          'border-top-color': getColorForPlans1(
                            plan.published.data[0],
                            plan.restrict
                          )
                        }"
                      ></span> -->
                      <!-- <div
                        *ngIf="role === 'ADMINISTRATOR'"
                        title="{{
                          getTextForTooltip(
                            plan.published.data[0],
                            plan.restrict
                          )
                        }}"
                        [ngStyle]="{
                          'border-color': getColorForPlans(
                            plan.published.data[0],
                            plan.restrict
                          )
                        }"
                        class="outer my-auto col-2"
                        data-bs-toggle=""
                      >
                        <span
                          class="inner"
                          [ngStyle]="{
                            background: getColorForPlans(
                              plan.published.data[0],
                              plan.restrict
                            )
                          }"
                        ></span>
                      </div> -->
                    </div>
                    <div class="mt-2 mx-1" *ngIf="showPricing && plan.id == 5">
                      <label class="Corporation">{{
                        lang?.Pricing ?? "Pricing"
                      }}</label>
                      <select
                        class="form-control1 py-1 text-dark ms-2"
                        style="width: auto"
                        id="pricingOptions"
                        placeholder="Select"
                        [(ngModel)]="editFormPricingOptions"
                      >
                        <option value="">Select</option>
                        <option
                          *ngFor="let option of pricingOptions"
                          [value]="option.key"
                        >
                          {{ option.display }}
                        </option>
                      </select>
                    </div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <i
          *ngIf="isScrollableAdv"
          class="chevron chevron-right fa bi-chevron-right right--chevron"
          (click)="scrollRightAdv()"
        ></i>
      </div>
    </div>
  </section>
</main>

<div
  class="modal fade"
  id="viewPlanDetails"
  data-backdrop="static"
  tabindex="-1"
>
  <div
    class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    id="modal-dialog"
    style="min-width: 1000px; max-width: 1000px !important"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">
          {{ planDetails.name }}
        </h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12 d-flex justify-content-evenly tabs">
            <div
              class="tab w-100 justify-content-between"
              *ngFor="let category of categories"
              [ngClass]="{ active: selectedCategory == category }"
              (click)="changeCategory(category)"
            >
              {{ category }}
            </div>
          </div>

          <div *ngIf="selectedCategory == 'Member List'">
            <div class="table-responsive position-relative mt-2">
              <img
                src="../../../assets//img/download_list.png"
                class="download-list"
                *ngIf="memberList?.length > 0"
                (click)="downloadMembers()"
              />
              <table
                datatable
                [dtOptions]="dtOptions"
                id="DataTables_Table_0"
                [dtTrigger]="dtTrigger"
                class="table text-nowrap"
              >
                <thead>
                  <tr>
                    <th></th>
                    <th>{{ lang?.IGBMS_Id ?? "IGBMS Id" }}</th>
                    <!-- <th>{{ lang?.Type ?? "Type" }}</th> -->
                    <th>{{ lang?.Name ?? "Name" }}</th>
                    <th>{{ lang?.Email ?? "Email" }}</th>
                    <th>{{ lang?.Phone ?? "Phone" }}</th>
                    <th>
                      {{ lang?.Registration_Date ?? "Registration Date" }}
                    </th>
                    <th>{{ lang?.Status ?? "Status" }}</th>
                    <!-- <th></th> -->
                  </tr>
                </thead>

                <tbody *ngIf="!restLoader; else loadingState">
                  <tr *ngFor="let client of memberList; let i = index">
                    <td class="my-auto">
                      <i
                        *ngIf="client?.bulkPlanIncluded"
                        class=""
                        style="
                          font-size: 14px;
                          color: rgb(31, 31, 29);
                          font-family: system-ui;
                          font-weight: 600;
                        "
                        title="Bulk/Group Plan Member"
                        >B</i
                      >
                      <i
                        *ngIf="
                          client?.greenshieldMemberId ||
                          client?.greenshieldRegistrationStatus
                        "
                        style="
                          font-size: 14px;
                          color: green;
                          font-family: system-ui;
                          font-weight: 600;
                        "
                        title="Greenshield Member"
                        >G</i
                      >
                      <i
                        *ngIf="
                          client?.equitableCertificateId ||
                          client?.equitableRegistrationStatus
                        "
                        style="
                          font-size: 14px;
                          color: #2762b9;
                          font-family: system-ui;
                          font-weight: 600;
                        "
                        title="Equitable Member"
                        >E</i
                      >
                    </td>

                    <td>{{ client?.fusebillCustomerId }}</td>

                    <!-- <td>
                      {{ client?.isCorporateAccount ? "CORP" : "GIG" }}
                    </td> -->

                    <td (click)="showDetails(client)" style="cursor: pointer">
                      <span
                        class="viewCorporate"
                        data-bs-target="#memberdetails"
                        data-bs-toggle="modal"
                        >{{ client?.firstName | titlecase }}
                        {{ client?.lastName | titlecase }}</span
                      >
                    </td>
                    <td>{{ client?.username ?? "" }}</td>

                    <ng-template
                      [ngIf]="client?.primaryPhone == undefined"
                      [ngIfElse]="contactInformations"
                    >
                      <td></td>
                    </ng-template>
                    <ng-template #contactInformations>
                      <td>{{ client?.primaryPhone ?? "" }}</td>
                    </ng-template>

                    <ng-template
                      [ngIf]="
                        client?.registrationDate?.includes('00-00') ?? true
                      "
                      [ngIfElse]="registrationDate"
                    >
                      <td></td>
                    </ng-template>
                    <ng-template #registrationDate>
                      <td>
                        {{ client?.registrationDate | date : "MM/dd/yyyy" }}
                      </td>
                    </ng-template>
                    <td>
                      <span
                        class="brokertablestatus mx-1 text-center"
                        *ngIf="
                          client?.terminationDate != null &&
                            client?.terminationReason != null;
                          else normalstatus
                        "
                        >Terminated
                      </span>
                      &nbsp;<span style="margin-left: -21px">
                        <i
                          class="fa fa-info-circle"
                          id="tooltip"
                          style="cursor: pointer"
                          *ngIf="
                            client?.terminationDate != null &&
                            client?.terminationReason != null
                          "
                        >
                          <table class="tooltiptext ignoreTable">
                            <tbody>
                              <tr class="ignoreTable">
                                <td>
                                  Date:{{ client?.terminationDate | date }}
                                </td>
                              </tr>
                              <tr class="ignoreTable">
                                <td>Reason:{{ client?.terminationReason }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </i>
                      </span>
                      <ng-template #normalstatus>
                        <span class="brokertablestatus mx-1 text-center">{{
                          client?.status
                        }}</span>
                      </ng-template>
                    </td>

                    <!-- <td class="d-flex justify-content-end">
                      <div *ngIf="!client?.isCorporateAccount && role==='ADMINISTRATOR'">
                        <span class="brokertablestatus mx-1 text-center" style="cursor:pointer"
                          (click)="gigtoCorp(client)">Convert to Corp</span>
                      </div>
                      <div style="min-width: 20px;" data-bs-target="showmemberlist">
                        <a *ngIf="(client?.status=='Active' || client?.status=='Draft') && (role==='ADMINISTRATOR' || role==='BROKER')"
                          class="viewicon" title="{{lang?.Terminate}}" data-toggle="tooltip" style="cursor: pointer;"><i
                            class="fa fa-trash-o pe-1" style="color:red; font-size:15px"
                            (click)="terminatemember(client,i)"></i></a>&nbsp;
                      </div>
                      <div style="min-width: 20px;">
                        <a class="viewicon"
                          *ngIf="(client?.status == 'Active' || client?.status == 'Hold')  && client?.bulkPlanIncluded!=true"
                          title="{{lang?.Send_Invite}}" data-toggle="tooltip">
                          <i class="fa fa-send-o cursor: pointer;" style="color:rgb(56,76,159);cursor: pointer;"
                            (click)="invitationMail(client)">
                          </i></a>&nbsp;
                      </div>
                    </td> -->
                  </tr>
                </tbody>

                <ng-template #loadingState>
                  <tr
                    *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                    class="loader"
                  >
                    <td *ngFor="let j of [1, 2, 3, 4, 5, 6, 7]">
                      <div class="is-loading">
                        <p></p>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </table>
            </div>
          </div>
          <div *ngIf="selectedCategory == 'Plan Details'">
            <div>
              <!-- <div class="feature" *ngFor="let feature of planLevelFeatures.features; let i = index">
                <h6 class="feature-heading">{{feature.feature}}</h6>
                <p class="feature-content" [innerHTML]="feature.content"></p>
              </div> -->

              <div class="feature-container">
                <div class="feature-column" *ngIf="leftFeatures?.length > 0">
                  <div class="feature" *ngFor="let feature of leftFeatures">
                    <h6 class="feature-heading" *ngIf="feature.feature != ''">
                      {{ feature.feature }}
                    </h6>
                    <span
                      class="feature-content"
                      [innerHTML]="feature.content"
                    ></span>
                  </div>
                </div>

                <div class="feature-column" *ngIf="rightFeatures?.length > 0">
                  <div class="feature" *ngFor="let feature of rightFeatures">
                    <h6 class="feature-heading" *ngIf="feature.feature != ''">
                      {{ feature.feature }}
                    </h6>
                    <span
                      class="feature-content"
                      [innerHTML]="feature.content"
                    ></span>
                  </div>
                </div>

                <div
                  *ngIf="rightFeatures?.length == 0 && leftFeatures.length == 0"
                  class="d-flex justify-content-center"
                >
                  No Data Available
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          tooltip="List will be replaced overwriting existing."
          id="closeaddadmin"
          data-bs-dismiss="modal"
          #closemodel
        >
          {{ lang?.Close ?? "Close" }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="bulkPlanList" data-backdrop="static" tabindex="-1">
  <div
    class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    id="modal-dialog"
    style="min-width: 1000px; max-width: 1000px !important"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">
          {{ planDetails.name }}
        </h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12 d-flex justify-content-evenly tabs">
            <div
              class="tab w-100 justify-content-between"
              *ngFor="let category of categories"
              [ngClass]="{ active: selectedCategory == category }"
              (click)="changeCategory(category)"
            >
              {{ category }}
            </div>
          </div>

          <div *ngIf="selectedCategory == 'Member List'">
            <div class="table-responsive position-relative mt-2">
              <img
                src="../../../assets//img/download_list.png"
                class="download-list"
                *ngIf="memberList?.length > 0"
                (click)="downloadBulkMembers()"
              />
              <table
                datatable
                [dtOptions]="dtOptions1"
                id="DataTables_Table_1"
                [dtTrigger]="dtTrigger"
                class="table text-nowrap"
              >
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Company</th>
                    <th>Headcount</th>
                  </tr>
                </thead>

                <tbody *ngIf="!restLoader; else loadingState">
                  <tr *ngFor="let client of memberList; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ client?.brokerName || "-" }}</td>
                    <td>{{ client?.quantity ?? 0 }}</td>
                  </tr>
                </tbody>

                <ng-template #loadingState>
                  <tr
                    *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                    class="loader"
                  >
                    <td *ngFor="let j of [1, 2, 3]">
                      <div class="is-loading">
                        <p></p>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </table>
            </div>
          </div>
          <div *ngIf="selectedCategory == 'Plan Details'">
            <div>
              <!-- <div class="feature" *ngFor="let feature of planLevelFeatures.features; let i = index">
                <h6 class="feature-heading">{{feature.feature}}</h6>
                <p class="feature-content" [innerHTML]="feature.content"></p>
              </div> -->

              <div class="feature-container">
                <div class="feature-column" *ngIf="leftFeatures?.length > 0">
                  <div class="feature" *ngFor="let feature of leftFeatures">
                    <h6 class="feature-heading" *ngIf="feature.feature != ''">
                      {{ feature.feature }}
                    </h6>
                    <span
                      class="feature-content"
                      [innerHTML]="feature.content"
                    ></span>
                  </div>
                </div>

                <div class="feature-column" *ngIf="rightFeatures?.length > 0">
                  <div class="feature" *ngFor="let feature of rightFeatures">
                    <h6 class="feature-heading" *ngIf="feature.feature != ''">
                      {{ feature.feature }}
                    </h6>
                    <span
                      class="feature-content"
                      [innerHTML]="feature.content"
                    ></span>
                  </div>
                </div>

                <div
                  *ngIf="rightFeatures?.length == 0 && leftFeatures.length == 0"
                  class="d-flex justify-content-center"
                >
                  No Data Available
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          tooltip="List will be replaced overwriting existing."
          id="closeaddadmin"
          data-bs-dismiss="modal"
          #closemodel
        >
          {{ lang?.Close ?? "Close" }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="edit-headcount" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title w-100 text-center">Edit Head Count</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <!-- <div *ngFor="let package of bulkPlansData; let i = index">
          <div class="form-group" style="margin-top:-2px">
            <div *ngFor="let group of package?.groups; let j = index" class="one">
              <div *ngIf="group && group?.subGroups && group?.subGroups?.length > 0" class="two">
                <div *ngFor="let subgroup of group?.subGroups; let k = index" class="three">
                  <div *ngIf="subgroup" id="collapsethreeBulk{{
                      package?.groups?.length >  1
                        ? subgroup.parentId
                        : package?.id
                    }}" class="">
                    <div>
                      <div id="checkbox-{{subgroup.id}}"
                        *ngIf="checkboxCheck[subgroup.id]==true"
                        class="countblock">

                        <table class="border-0">
                          <tbody>

                            <tr class="bg-transparent">
                              <td>
                                <label for="Corporation" class="Corporation">Current Head Count</label>
                              </td>
                              <td>
                                <input type="number" class="headcountbox" [(ngModel)]="currentHeadCount"
                                  class="headerCount" (keypress)="preventNegative($event)"
                                  (input)="preventNonNumeric($event)"
                                  (change)="updateBulkHeadCountTotal($event,subgroup,subgroup.settings?.requiredCustomersCount)"
                                  disabled>&nbsp;
                                &nbsp;
                                <span class="text-left"
                                  *ngIf="checkboxCheck[subgroup.id] && showinputboxvalue[subgroup.id] && (showHeadCount[subgroup.id] || showHeadCount[subgroup.id] >0)">
                                  <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                    (click)="editEmployees(subgroup.id,'view','show')"></i>
                                </span>
                              </td>
                            </tr>

                            <tr class="bg-transparent">
                              <td>
                                <label for="Corporation" class="Corporation">New Head Count</label>
                              </td>
                              <td>
                                <input type="number" class="headcountbox" [(ngModel)]="newHeadCount" class="headerCount"
                                  (keypress)="preventNegative($event)" (input)="preventNonNumeric($event)"
                                  >&nbsp;
                                <label for="Corporation" class="Corporation" *ngIf="!newHeadCount || newHeadCount <=0"
                                  style="color:red">
                                  {{lang.Please_enter_head_count_for}} {{subgroup?.name}}</label>
                                &nbsp;

                                <span class="text-left"
                                  *ngIf="checkboxCheck[subgroup.id] && showinputboxvalue[subgroup.id] && (showHeadCount[subgroup.id] || showHeadCount[subgroup.id] >0)">
                                  <label for="DownloadButton" id="uploadButtonExcel" title="Download Template"
                                    data-taggle="tooltip"
                                    (click)="exportAsXLSX(subgroup.id,subgroup.settings.memberDetailsKeysDB)"
                                    class="Cursorpointer">
                                    <img src="../../../assets/img/download-template.png"
                                      style="width:100px;height:30px">
                                  </label>&nbsp;
                                  <label for="uploadButton-{{subgroup.id}}" id="uploadButtonExcel-{{subgroup.id}}"
                                    title="Upload Employee/Entity List" data-taggle="tooltip" class="Cursorpointer">
                                    <img src="../../../assets/img/upload-employee-list.png"
                                      style="width:100px;height:30px">
                                    <input id="uploadButton-{{subgroup.id}}" #myFileInput style="display: none"
                                      type="file"
                                      (input)="onFileChangeExcel($event,subgroup.id,subgroup.settings.memberDetailsKeysDB)" />
                                  </label> &nbsp;
                                  <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                    (click)="editEmployees(subgroup.id,'edit','show')"></i>
                                </span>
                              </td>
                            </tr>

                            <tr class="bg-transparent">
                              <td>
                                <label>Effective Date</label>
                              </td>
                              <td>
                                <select class="form-control1" style="width:auto; font-size: 14px;" id="lengthofService"
                                  [(ngModel)]="effectiveDate">
                                  <option [value]="null||''" disabled>Select</option>
                                  <option *ngFor="let date of dateOptions" [value]="date.value">{{ date.text }}</option>
                                </select>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div *ngIf="nonEditingBulkPlan" class="d-flex">
                          <input type="checkbox"  id="expandActivePlanExpiry" />&nbsp;
                          <label for="expandActivePlanExpiry" class="mx-2">
                            Expand termination date of active plan to activation date of provisioning plan
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <table class="border-0">
          <tbody>

            <tr class="bg-transparent">
              <td>
                <label for="Corporation" class="Corporation">Current Head Count</label>
              </td>
              <td>
                <input type="number" class="headcountbox" [(ngModel)]="currentHeadCount"
                  class="headerCount" (keypress)="preventNegative($event)"
                  (input)="preventNonNumeric($event)"
                  (change)="updateBulkHeadCountTotal($event,currentPlan,currentPlan.settings?.requiredCustomersCount)"
                  disabled>&nbsp;
                &nbsp;
                <span class="text-left"
                  *ngIf="currentHeadCount>0">
                  <i class="fa fa-eye" *ngIf="currentPlan?.showMemberDetailsDB ?? currentPlan?.showMemberDetails" title="view" aria-hidden="true" data-bs-toggle="modal"
                    (click)="editEmployees(subgroup.id,'view','show')"></i>
                </span>
              </td>
            </tr>

            <tr class="bg-transparent">
              <td>
                <label for="Corporation" class="Corporation">New Head Count</label>
              </td>
              <td>
                <input
                  type="number"
                  class="headcountbox headerCount"
                  [(ngModel)]="newHeadCount"
                  (keypress)="preventNegative($event)"
                  (input)="onHeadCountInput($event)"
                  min="0"
                  max="100000"
                />&nbsp;&nbsp;
                <label for="Corporation" class="Corporation" *ngIf="!newHeadCount || newHeadCount <=0"
                  style="color:red">
                  {{lang?.Please_enter_head_count_for}} {{currentPlan?.name}}</label>
                &nbsp;

                <span class="text-left"
                  *ngIf="(currentPlan?.settings?.showMemberDetailsDB ?? currentPlan?.showMemberDetails) && newHeadCount > 0">
                  <label for="DownloadButton" id="uploadButtonExcel" title="Download Template"
                    data-taggle="tooltip"
                    (click)="productListApplicable ?
                      exportAsXLSXProducts(currentPlan?.id,currentPlan.settings.memberDetailsKeysDB) :
                      exportAsXLSX(currentPlan.id,currentPlan?.settings?.memberDetailsKeysDB)"
                    class="Cursorpointer">
                    <img src="../../../assets/img/download-template.png"
                      style="width:100px;height:30px">
                  </label>&nbsp;
                  <label for="uploadButton-{{currentPlan.id}}" id="uploadButtonExcel-{{currentPlan.id}}"
                    title="Upload Employee/Entity List" data-taggle="tooltip" class="Cursorpointer">
                    <img src="../../../assets/img/upload-employee-list.png"
                      style="width:100px;height:30px">
                    <input id="uploadButton-{{currentPlan.id}}" #myFileInput style="display: none"
                      type="file"
                      (input)="onFileChangeExcel($event,currentPlan.id,currentPlan?.settings?.memberDetailsKeysDB)" />
                  </label> &nbsp;
                  <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                    (click)="editEmployees(currentPlan.id,currentPlan?.settings?.productListApplicable)"></i>
                </span>
              </td>
            </tr>

            <tr 
              class="bg-transparent" 
              *ngIf="currentPlan.settings?.requiredCustomersCount > 0 && getMismatchedEmployeeList(currentPlan.id)"
            >
              <td colspan="2" style="color: red;">
                Employee list and headcount are not matched
              </td>
            </tr>
            <tr class="bg-transparent" *ngIf="newHeadCount < currentPlan.settings?.requiredCustomersCount">
              <td colspan="2" style="color: red;">
                Headcount must be at least {{ currentPlan.settings?.requiredCustomersCount > 0 ? currentPlan.settings?.requiredCustomersCount : 1 }}
              </td>
            </tr>

            <tr class="bg-transparent">
              <td>
                <label>Effective Date</label>
              </td>
              <td>
                <select class="form-control1" style="width:auto; font-size: 14px;" id="lengthofService"
                  [(ngModel)]="effectiveDate" (change)="effectiveDateChanged($event)">
                  <option *ngFor="let date of dateOptions" [value]="date.value">{{ date.text }}</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" tooltip="Close" id="closeaddadmin" data-bs-dismiss="modal"
          #closemodel>
          {{lang?.Close ?? 'Close'}}
        </button>
        <!-- (employeeList.length>0 && employeeList.length!=newHeadCount) ||-->
        <button type="button" class="btn btn-primary saveAndNext" tooltip="Save" data-bs-dismiss="modal"
          style="background:rgb(56, 76, 159) !important;color:white !important;" (click)="saveHeadCount()"
          [disabled]="(
            !newHeadCount || newHeadCount == 0) ||
            newHeadCount < currentPlan.settings?.requiredCustomersCount
            ">
          {{lang?.Update ?? 'Update'}}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="terminate-bulkplan" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title w-100 text-center">Terminate {{editPlanHeadCount.planLevel}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-12 mb-3">
            Choose termination date to expire {{editPlanHeadCount.planLevel}} plan of headcount
            {{editPlanHeadCount.quantity}}
          </div>

          <div class="col-4 mb-3">
            <label>Effective Date</label>
          </div>
          <div class="col-8 mb-3">
            <select class="form-control1" style="width:auto; font-size: 14px;" id="lengthofService"
              [(ngModel)]="effectiveDate" (change)="changeTerminationDate()">
              <option *ngFor="let date of dateOptions" [value]="date.value">{{ date.text }}</option>
            </select>
          </div>

          <div *ngIf="showActivateOldPlan">
            <input type="checkbox" [checked]="activateOldPlan" (click)="toggleActivateOldPlan()"
              id="activateOldPlan" />&nbsp;
            <label for="activateOldPlan" class="mx-2">Continue with the old existing plan heacount?</label>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" tooltip="Close" id="closeaddadmin" data-bs-dismiss="modal"
          #closemodel>
          {{lang?.Close??'Close'}}
        </button>
        <button type="button" class="btn btn-primary saveAndNext" tooltip="Save" data-bs-dismiss="modal"
          style="background:rgb(56, 76, 159) !important;color:white !important;" (click)="submitExpiration()"
          [disabled]="effectiveDate==null">
          {{lang?.Save??'Save'}}
        </button>

      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>